import i18next from "i18next";
import { initReactI18next } from "react-i18next";

i18next.use(initReactI18next).init({
  lng: localStorage.getItem("i18nLang") || undefined,
  fallbackLng: "en",
  defaultNS: "common",
  interpolation: { escapeValue: false },
  resources: {
    en: {
      common: {
        generic: {
          first_name: "First name",
          last_name: "Last name",
          email: "Email",
          role: "Role",
          logout: "Log out",
          action_save: "Save",
        },
        settings: {
          profile: "Profile",
          organization_settings: "Organization settings",
          changes_saved: "Changes saved",
          changes_saved_message: "Your profile changes have been saved",
          change_password: "Change password",
          set_password: "Set password",
        },
      },
      Auth: {
        name_placeholder: "John Doe",
        email_placeholder: "doe@example.com",
        register: "Register",
        name: "Name",
        current_password: "Current password",
        new_password: "New password",
        change_password: "Change password",
        title: "Login to Veft",
        invalid_email: "Invalid email",
        invalid_password: "Password should include at least 8 characters",
        login_failed: "Login failed",
        incorrect_user_or_password: "Incorrect user or password",
        rate_limit_exceeded: "Too many login attempts. Please try again later.",
        unexpected_error: "An unexpected error has occurred: ",
        email: "Email",
        password: "Password",
        your_password: "Your password",
        forgot_password: "Forgot password?",
        login: "Login",
        you_are_logged_in: "You are logged in",
        password_reset_requested: "Password reset requested",
        password_reset_requested_message:
          "Please check your email and follow the reset link to set a new password.",
        recover_password: "Recover password",
        request_reset_email: "Send recovery email",
        login_instead: "Login instead",
        passkey_required_login:
          "Your organization requires passkey sign-in. Please sign in with your passkey.",
      },
      Users: {
        add_user: "Add user",
        email: "Email",
        first_name: "First name",
        last_name: "Last name",
        role: "Role",
        created: "Created",
        is_active: "Active",
        user_deleted: "User deleted!",
        invite_user: "Invite user",
        invitation_sent: "Invitation sent!",
        invite_user_info:
          "This will send an invitation to the user so they can join you to collaborate.",
        save: "Save",
        edit: "Edit",
        delete: "Delete",
        details: "Details",
        versions: "Versions",
        reset_passkeys: "Reset passkeys",
        reset_passkeys_confirm:
          "Reset this user's passkeys? They will sign in with their password and be prompted to create a new passkey. Use this to recover a lost or stolen device.",
        reset_passkeys_done_title: "Passkeys reset",
        reset_passkeys_done_msg:
          "The user can now sign in with their password and enroll a new passkey.",
        reset_passkeys_error_title: "Couldn't reset passkeys",
      },
      FIDO: {
        fidoKey: {
          registeredSuccess: "Passkey registered successfully",
          keyAdded: "Your passkey has been added",
          fetchError: "Error fetching passkeys",
          deletedSuccess: "Passkey deleted successfully",
          keyRemoved: "Passkey removed",
          deleteError: "Error deleting passkey",
          lastUsed: "Last used",
          created: "created",
          actions: {
            add: "Add passkey",
            remove: "Remove passkey",
          },
          title_passkeys: "Passkeys",
        },
        registerError: "Error registering passkey",
      },
      Veft: {
        // Shared
        name: "Name",
        title: "Title",
        location: "Location",
        email: "Email",
        phone: "Phone",
        industry: "Industry",
        save: "Save",
        cancel: "Cancel",
        add: "Add",
        create: "Create",
        delete: "Delete",
        back: "Back",
        search: "Search",
        tags: "Tags",
        status: "Status",
        date: "Date",
        no_data: "—",

        // Candidates (rebranded as Contacts in the UI; entity remains Candidate in backend)
        candidates: "Contacts",
        profiles_count: "{{count}} profiles",
        add_candidate: "Add Contact",
        search_candidates: "Search contacts by name...",
        no_candidates: "No contacts found.",
        sort_label: "Sort",
        sort_recent: "Recent",
        sort_alpha: "Alphabetical",
        name_format_label: "Name format",
        name_format_first_last: "First Last",
        name_format_last_first: "Last, First",
        current_role: "Current Role",
        open_to_work: "Open to work",
        updated_ago: "Updated {{ago}}",
        consent: "Consent",
        filter: "Filter",
        call: "Call",
        send_email: "Email",
        filter_by_consent: "Filter by consent",
        consent_status_notRequested: "Not requested",
        consent_status_requested: "Requested",
        consent_status_overdue: "Overdue",
        consent_status_granted: "Granted",
        consent_status_declined: "Declined",
        consent_status_expired: "Expired",
        consent_status_withdrawn: "Withdrawn",
        consent_status_suppressed: "Won't ask",
        consent_manage: "Manage consent",
        consent_send_request: "Send consent request",
        consent_no_email_warning: "This contact has no email address, so a consent request can't be sent. Add an email to the contact, or record consent offline below.",
        consent_not_activated_warning: "Consent sending is not activated yet. Review the template and activate it under Settings → Consent before sending requests.",
        consent_event_requestCreated: "Request created",
        consent_event_requestSent: "Request sent",
        consent_event_requestResent: "Request resent",
        consent_event_requestViewed: "Request viewed",
        consent_event_approved: "Approved",
        consent_event_declined: "Declined",
        consent_event_withdrawn: "Withdrawn",
        consent_event_expired: "Expired",
        consent_event_requestRevoked: "Request revoked",
        consent_event_markedNotRequired: "Marked not required",
        consent_event_offlineConsentRecorded: "Offline consent recorded",
        consent_event_suppressionSet: "Marked \"won't ask\"",
        consent_event_suppressionCleared: "Cleared \"won't ask\"",
        consent_actor_staff: "Staff",
        consent_actor_subject: "Subject",
        consent_actor_system: "System",
        consent_resend: "Resend",
        consent_revoke: "Revoke",
        consent_pending_sent_to: "Pending — sent to {{email}}",
        consent_timeline: "History",
        consent_no_history: "No consent activity yet.",
        consent_record_offline: "Record offline consent",
        consent_mark_not_required: "Mark as \"won't ask\"",
        consent_clear_suppression: "Clear \"won't ask\"",
        consent_suppress_reason: "Reason (optional)",
        consent_download_certificate: "Certificate",
        consent_validity: "Validity",
        consent_until: "until",
        consent_indefinite: "indefinite",
        consent_requests: "Requests",
        consent_save: "Save",
        full_name: "Full name",
        first_name: "First name",
        last_name: "Last name",
        last_name_required: "Last name is required",
        title_placeholder: "e.g. Chief Financial Officer",
        company_placeholder: "e.g. Siemens AG",
        location_placeholder: "e.g. Berlin, Germany",
        location_search_placeholder: "Search city or country…",
        geo_type_place: "City",
        geo_type_region: "Region",
        geo_type_country: "Country",
        geo_radius_label: "Radius",
        geo_radius_exact: "This place only",
        geo_radius_option: "+{{km}} km",
        geo_lookup_failed: "Location lookup failed",
        filter_location_chip: "Location: {{place}}",
        filter_location_chip_radius: "Location: {{place}} +{{km}} km",
        search_place_chip: "Only show contacts in {{place}}",
        search_place_chip_dismiss: "Dismiss suggestion",
        view_list: "List",
        view_list_aria: "List view",
        view_map: "Map",
        view_map_aria: "Map view",
        map_no_location_badge_one: "{{count}} contact without location data",
        map_no_location_badge_other: "{{count}} contacts without location data",
        map_capped_hint: "Showing the {{count}} most recently updated contacts",
        map_empty: "No contacts with location data match these filters",
        map_error: "The map could not be loaded",
        map_retry: "Retry",
        map_not_configured: "The map view is not configured for this environment",
        email_placeholder: "email@example.com",
        phone_placeholder: "+49 ...",
        linkedin_url: "LinkedIn URL",
        enrichment_failed: "Enrichment failed",
        enrichment_error: "Last error",
        enriching: "Enriching...",
        no_role_info: "No role info",
        trash: "Trash",
        import: "Import",
        find_similar: "Find Similar",
        more_actions: "More actions",
        delete_candidate: "Delete Contact",
        delete_confirm: "Are you sure you want to delete {{name}}? This can be undone within 30 days.",
        gdpr: "GDPR: {{status}}",

        // Deleted candidates (trash)
        deleted_candidates_title: "Deleted Contacts",
        deleted_candidates_count: "{{count}} in trash",
        deleted_candidates_retention: "Deleted contacts are permanently removed after 30 days.",
        deleted_candidates_empty: "Trash is empty.",
        deleted_col_deleted: "Deleted",
        deleted_col_purge: "Auto-purge",
        deleted_purge_days_one: "in {{count}} day",
        deleted_purge_days_other: "in {{count}} days",
        deleted_purge_imminent: "Imminent",
        restore_success_title: "Restored",
        restore_success_msg: "{{name}} has been restored",
        deleted_restore_failed: "Failed to restore contact",

        // Candidate profile tabs
        tab_timeline: "Activity",
        imported_note_outlook: "Imported note (Outlook)",
        read_only: "read-only",
        remove: "Remove",
        tab_summary: "Summary",
        tab_career: "Career",
        tab_notes: "Notes",
        tab_tags: "Tags",
        tab_documents: "Documents",
        tab_projects: "Projects",

        // Key facts
        key_facts: "Key Facts",
        phone_numbers: "Phone Numbers",
        metadata: "Metadata",
        languages: "Languages",
        skills: "Skills",
        add_skill: "Add skill...",
        enrichment: "Enrichment",
        sources: "Sources",
        documents_count: "{{count}} documents",
        gdpr_consent: "GDPR Consent",
        timeline_entries: "Timeline entries",
        last_interaction: "Last interaction",
        first_contact: "First contact",
        show_less: "show less",
        show_more: "show more",

        // Phone numbers
        phone_label: "Phone:",
        add_phone: "Add phone",
        phone_number: "Phone number",
        phone_mobile: "Mobile",
        phone_mobilePrivate: "Mobile (private)",
        phone_office: "Office",
        phone_home: "Home",

        // Emails
        email_label: "Email:",
        add_email: "Add email",
        email_address: "Email address",
        email_business: "Business",
        email_personal: "Personal",
        primary: "Primary",
        make_primary: "Make primary",

        // Postal addresses (structured, distinct from the free-text Location)
        addresses_label: "Addresses:",
        add_address: "Add address",
        address_business: "Business",
        address_personal: "Private",
        address_other: "Other",
        address_line1: "Street and number",
        address_line2: "Suite / c/o (optional)",
        address_postal_code: "Postal code",
        address_city: "City",
        address_region: "State / region",
        address_country: "Country",

        // Compensation
        compensation: "Compensation",
        comp_total: "Total:",
        comp_base: "Base:",
        comp_note: "Note:",
        comp_as_of: "As of {{date}}",
        comp_breakdown: "Breakdown",
        comp_currency: "Currency",
        comp_add: "Add compensation",
        comp_remove: "Remove",
        comp_manual: "entered manually",
        comp_note_placeholder: "e.g. told over the phone; expects ~15% uplift",
        comp_breakdown_preserved: "The structured breakdown from the uploaded document is kept.",
        comp_kind_base: "Base",
        comp_kind_bonus: "Bonus",
        comp_kind_commission: "Commission",
        comp_kind_ltip: "LTIP",
        comp_kind_equity: "Equity",
        comp_kind_allowance: "Allowance",
        comp_kind_pension: "Pension",
        comp_kind_oneTime: "One-time",
        comp_kind_other: "Other",
        comp_period_monthly: "month",
        comp_period_annual: "year",
        comp_period_oneTime: "one-time",
        // Document kind (content classification of an uploaded document)
        doc_kind_cv: "CV",
        doc_kind_compensation: "Compensation",
        doc_kind_consentForm: "Consent form",
        doc_kind_other: "Document",

        // Summary
        summary: "Summary",
        no_summary: "No summary available.",
        notes: "Notes",
        no_notes: "No notes.",
        notes_imported_hint: "Imported from the contact card. Structured data (compensation, LinkedIn) is mined from this automatically.",
        credits_remaining_tooltip: "{{credits}} credits remaining",
        // Import page (/candidates/import)
        import_title: "Import Candidates",
        import_subtitle: "Upload a .vcf/.zip file, or import contacts directly from your Microsoft 365 Outlook account.",
        import_upload_button: "Upload VCF or ZIP",
        import_limit_all: "All",
        import_from_outlook: "Import from Outlook",
        import_admin_consent_tooltip: "If your Microsoft 365 admin needs to approve the app, get a link to send them",
        import_get_admin_consent: "Get admin-consent link",
        import_admin_consent_title: "Admin-consent link",
        import_admin_consent_body: "Forward this link to your Microsoft 365 admin. They sign in with their admin account and click <b>Accept</b> to authorize Veft to read contacts for users in your tenant. After that, run the regular Outlook import.",
        import_copied: "Copied",
        import_copy_link: "Copy link",
        import_open_new_tab: "Open in new tab",
        import_zip_upgrade: "Bulk folder/ZIP import is available on the Pro plan. Please upgrade to import candidate archives.",
        import_zip_help_title: "How to structure a ZIP for import",
        import_zip_help_intro: "Each candidate is <b>one top-level folder</b> in the zip. Put the candidate folders at the archive root — don't wrap them all inside a single parent folder.",
        import_zip_tree_optional: "← optional",
        import_zip_tree_contact: "← optional (email, phone, title…)",
        import_zip_help_footnote: "Also supported: a single <b>.vcf with many contacts</b> → one candidate per contact, and loose CV files at the top level → one candidate per file. A stray wrapping parent folder is auto-detected and unwrapped, but a flat layout is the most reliable.",
        import_no_sessions: "No import sessions yet. Upload a file to get started.",
        import_col_file: "File",
        import_col_type: "Type",
        import_col_items: "Items",
        import_col_status: "Status",
        import_col_date: "Date",
        import_uploaded: "Uploaded",
        import_upload_failed: "Upload failed",
        import_outlook_failed: "Outlook import failed",
        import_admin_consent_failed: "Could not build admin-consent link",
        import_deleted: "Deleted",
        import_parsing_background: "Parsing in the background — this can take a few minutes for large archives.",
        import_candidates_parsed: "{{n}} candidates parsed",
        import_status_parsing: "parsing",
        import_status_review: "review",
        import_status_committing: "committing",
        import_status_done: "done",
        import_status_failed: "failed",
        import_item_status_parsed: "ready",
        import_item_status_skipped: "skipped",
        import_item_status_duplicate: "duplicate",
        import_item_status_committed: "imported",
        import_item_status_failed: "failed",
        import_aria_include: "Include in import",
        import_aria_edit: "Edit details",
        import_aria_toggle_all: "Toggle all on this page",
        import_field_title: "Title",
        import_field_company: "Company",
        import_field_email: "Email",
        import_field_phone: "Phone",
        import_field_location: "Location",
        import_back: "Back",
        import_error: "Error",
        import_error_title: "Import error",
        import_session_not_found: "Session not found",
        import_contacts_fetched_title: "Contacts fetched",
        import_contacts_ready: "{{n}} contacts ready for review",
        import_complete_title: "Import complete",
        import_candidates_imported: "{{n}} candidates imported",
        import_failed_title: "Import failed",
        import_no_duplicates_title: "No duplicates",
        import_no_duplicates_msg: "All items are unique",
        import_dup_detection_failed: "Duplicate detection failed",
        import_start_failed: "Failed to start import",
        import_update_item_failed: "Failed to update item",
        import_update_items_failed: "Failed to update items",
        import_stat_total: "total",
        import_stat_imported: "imported",
        import_stat_skipped: "skipped",
        import_stat_duplicates: "duplicates",
        import_stat_ready: "ready",
        import_graph_attachments: "Attachments: {{fetched}} fetched from {{contacts}} contacts",
        import_graph_attachment_errors: ", {{errors}} fetch errors",
        import_parsing_zip: "Extracting candidates and uploading documents… This can take a few minutes for large archives.",
        import_parsing_graph: "Fetching contacts from Microsoft 365… This may take a few minutes for large contact lists.",
        import_committing: "Import in progress… candidates are being created and enrichment jobs queued.",
        import_completed_msg: "Import completed. {{n}} candidates were created.",
        import_duplicates_found: "{{n}} potential duplicates found",
        import_matches_existing: "matches existing: {{name}}",
        import_matches_item: "matches item: {{name}}",
        import_check_duplicates: "Check Duplicates",
        import_button_import_n: "Import {{n}} Candidates",
        import_select_all: "Select all on this page",
        colleagues_at: "Colleagues at {{company}}",
        colleagues_former: "Former",
        company_contacts: "Contacts ({{count}})",
        no_company_contacts: "No contacts are linked to this company yet.",
        currently_here: "Currently here",
        previously_here: "Previously here",
        company_not_found: "Company not found.",

        // Career
        career_history: "Career History",
        no_career: "No career history recorded.",
        role: "Role",
        company: "Company",
        from: "From",
        to: "To",
        description: "Description",
        present: "present",
        // Prefix on a headline whose role is a past (ended) position — see candidateRole.js
        role_former_prefix: "prev.",

        // Education
        education: "Education",
        no_education: "No education recorded.",
        year: "Year",

        // Documents
        source_documents: "Source Documents",
        upload_document: "Upload Document",
        re_enrich: "Re-enrich",
        no_documents: "No source documents yet. Upload a CV or trigger enrichment.",
        processed: "Processed",
        pending: "Pending",
        preview: "Preview",
        hide: "Hide",
        download: "Download",

        // Tags
        no_tags: "No tags assigned.",
        tags_computed_help: "Tags are derived automatically from the candidate's data and cannot be edited directly.",
        sourced_by: "Sourced by",
        sourced_by_help: "People who introduced or sourced this contact. Adding them here marks them with the \"Source\" role.",
        add_tag: "Add tag...",
        suggested_tags: "Suggested Tags",
        select_all: "Select all",
        select_row: "Select row",
        selected_count: "{{count}} selected",
        select_hint: "Tick candidates to add them to a project",
        select: "Select",
        bulk_add_prompt: "Add {{count}} selected contact(s) to a project.",
        bulk_added_to_project: "Added {{added}} contact(s) to {{project}} ({{skipped}} already there).",
        bulk_add_tag: "Add tag",
        bulk_remove_tag: "Remove tag",
        bulk_delete: "Delete",
        delete_selected_title: "Delete Contacts",
        delete_selected_confirm_one: "Are you sure you want to delete {{count}} contact? This can be undone within 30 days.",
        delete_selected_confirm_other: "Are you sure you want to delete {{count}} contacts? This can be undone within 30 days.",
        contacts_deleted_msg_one: "{{count}} contact deleted",
        contacts_deleted_msg_other: "{{count}} contacts deleted",
        tag_to_remove: "Tag to remove",
        clear_selection: "Clear selection",
        tags_updated: "Tags updated",
        tags_updated_msg: "{{count}} contacts updated",
        apply: "Apply",
        no_results: "No results",

        // Timeline activities
        activity_meeting: "Meeting",
        activity_call: "Call",
        activity_email: "Email",
        activity_note: "Note",
        activity_compensation: "Compensation",
        activity_reference: "Reference",
        activity_status_change: "Status Change",
        activity_status_change_moved: "{{actor}} moved candidate from {{fromStage}} to {{toStage}}",
        activity_status_change_added: "{{actor}} added candidate at {{toStage}}",
        activity_unknown_user: "Unknown user",
        activity_field_change: "Change",
        activity_field_added: "{{actor}} set {{field}}: {{value}}",
        activity_field_removed: "{{actor}} cleared {{field}} (was: {{value}})",
        activity_field_changed: "{{actor}} changed {{field}}: {{from}} → {{to}}",
        activity_field_changed_prefix: "{{actor}} changed {{field}}",
        activity_field_added_prefix: "{{actor}} set {{field}}",
        activity_field_removed_prefix: "{{actor}} cleared {{field}}",
        activity_field_grouped: "{{actor}} updated {{field}} ({{count}} changes)",
        activity_candidate_created: "Contact added",
        activity_candidate_created_body: "{{actor}} added this contact",
        today: "Today",
        yesterday: "Yesterday",
        load_more: "Load more",
        history_view: "Version history",
        history_title: "Change history",
        history_loading: "Loading…",
        history_empty: "No previous versions yet.",
        history_removed: "(removed)",
        history_blank: "(empty)",
        history_restore: "Restore",
        history_restored: "Version restored.",
        activity_system: "System",
        add_note_placeholder: "Add a note... (what happened?)",
        delete_activity: "Delete activity",
        delete_activity_confirm: "Are you sure you want to delete this entry?",

        // Web findings
        web_findings: "Web Findings",
        web_findings_empty: "No web findings yet.",
        web_findings_empty_help: "Web search runs as part of enrichment — on import, when you add a document, or via Re-enrich — and looks for press, board roles, awards and publications.",
        web_findings_needs_context: "Add a title or company first — web search needs at least one to identify the right person.",
        enrich_incl_web: "Enrich incl. web search",
        documents_reenrich_hint: "Uploading a document or adding a transcript automatically re-runs enrichment (including web search).",
        enrich_linkedin: "LinkedIn",
        enrich_web: "Web",
        enrich_li_updated: "updated {{date}}",
        enrich_li_notyet: "not fetched yet",
        enrich_li_invalid: "link invalid",
        enrich_li_mismatch: "name mismatch — confirmation pending",
        enrich_li_nourl: "no URL",
        enrich_web_searched: "searched {{date}}",
        enrich_web_notyet: "not searched yet",
        enrich_web_nocontext: "needs a title or company to run",
        finding_board: "Board Positions",
        finding_press: "Press",
        finding_publications: "Publications",
        finding_awards: "Awards",
        finding_conferences: "Conferences",
        finding_other: "Other",

        // Clients
        clients: "Clients",
        add_client: "Add Client",
        no_clients: "No clients yet. Add your first client to get started.",
        company_name: "Company Name",
        company_name_placeholder: "e.g. MediaGroup AG",
        industry_placeholder: "e.g. Media, Technology",
        notes_placeholder: "Internal notes about this client...",
        contacts: "Contacts",
        add_contact: "Add Contact",
        no_contacts: "No contacts",
        role_position: "Role / Position",
        mobile: "Mobile",
        direct_dial: "Direct Dial",
        phone_main: "Phone (main)",
        assistant_name: "Assistant Name",
        assistant_phone: "Assistant Phone",
        assistant_mobile: "Assistant Mobile",
        contact_mobile: "Mobile: {{phone}}",
        contact_direct: "Direct: {{phone}}",
        contact_phone: "Phone: {{phone}}",
        contact_assistant: "Asst: {{name}}",
        link_to_candidate: "Search a person to add as contact...",
        linked_to: "Linked: {{name}}",
        link_contact_help: "Search and link an existing person. To add someone new, create them as a contact first.",
        already_linked: "Already linked",
        already_linked_msg: "{{name}} is already a contact on this client.",
        unlink: "Unlink",
        create_as_candidate: "Create as Person",
        view_profile: "View Profile",

        // Roles
        roles: "Roles",
        role_candidate: "Candidate",
        role_client: "Client",
        role_reference: "Reference",
        role_source: "Source",
        role_ident: "Identified",
        role_interestingPotential: "Potential",

        // Project candidate
        source_label: "Source",
        source_direct_approach: "Direct Approach",
        source_referral: "Referral",
        source_application: "Application",
        source_database: "Database",
        source_linkedin_recruiter: "LinkedIn Recruiter",

        // RHP draft
        generate_ai_draft: "Generate AI draft",
        draft_longlist_copy: "Write executive summary + remarks",
        draft_assessment_copy: "Write rating texts + personality",
        executive_summary: "Executive Summary",
        personality_notes: "Personality Notes",
        assessment_sections: "Assessment Sections",
        annotations: "Annotations",
        annotation_placeholder: "Add annotation...",
        annotations_help: "Notes visible in generated documents. Click an entry to edit.",
        verdict: "Verdict",
        verdict_unset: "—",
        verdict_go: "Go",
        verdict_nogo: "No-go",
        processing_remarks: "Processing Remarks",
        processing_remarks_help: "Notes from the AI about the data it worked with — quality issues, conflicting sources, ambiguities. Consultant-only; not included in client-facing documents. Dismiss once acknowledged.",
        draft_status_generating: "drafting…",
        draft_status_complete: "drafted",
        draft_status_failed: "draft failed",
        draft_last_generated: "last drafted {{date}}",
        draft_overwrite_title: "Overwrite existing content?",
        draft_overwrite_intro: "These fields already have content and would be replaced:",
        draft_overwrite_warning: "This cannot be undone. Empty fields will be filled either way.",
        draft_overwrite_confirm: "Overwrite",
        draft_continue: "Continue",
        draft_blocked_approved: "Approved content will be kept untouched:",
        draft_done: "AI draft ready",
        draft_done_msg: "The candidate's narrative fields have been updated.",
        draft_failed: "AI draft failed",
        draft_failed_msg: "Something went wrong generating the draft.",

        // Provenance
        provenance_ai_generated: "AI",
        provenance_human_edited: "Edited",
        provenance_human_written: "Consultant",
        provenance_human_approved: "Approved",
        approve: "Approve",
        approved: "Approved",

        // Competency × Assessment matrix
        competency_assessment: "Competencies — Requirement vs. Reality",
        competency_assessment_help: "Each card pairs the project's requirement (left) with the candidate's evidence (right). The score is the consultant's evaluation (1 = weakest, 5 = strongest); the narrative can be drafted by AI and approved per dimension.",
        requirement: "Requirement",
        reality: "Reality",
        score: "Score",
        score_scale_hint: "1 = weakest · 5 = strongest",
        no_requirement_set: "No requirement set yet — click to add.",
        edit_requirement: "Edit requirement",
        requirement_placeholder: "What does the role demand on this dimension?",
        assessment_narrative_placeholder: "How does the candidate measure up on this dimension?",
        scores_required_title: "Set scores first",
        scores_required_msg: "Rate the candidate on at least one competency dimension before writing rating texts and personality notes.",
        discard: "Discard",

        // References
        references: "References",
        references_help: "Other contacts who recommended or referenced this person for this project. Adding a referrer marks them with the \"Reference\" role.",
        references_search_placeholder: "Search contacts...",

        // Companies
        companies: "Companies",
        companies_count: "{{count}} companies",
        add_company: "Add Company",
        search_companies: "Search companies...",
        no_companies: "No companies found.",
        company_exists: "Company already exists",
        aliases: "Aliases",
        aliases_placeholder: "Alternative names, comma-separated",
        website: "Website",
        company_dedup_title: "Duplicate companies",
        company_dedup_body: "{{groups}} groups look like the same firm ({{sources}} extra records). The named company is kept. The others are merged into it, then deleted. Career links are rewritten. This cannot be undone.",
        company_dedup_merge_all: "Merge all groups",
        company_dedup_merge_group: "Merge this group",
        company_dedup_keep: "Keep",
        company_dedup_absorb: "Will be merged in",
        company_dedup_people: "{{count}} people",
        company_dedup_has_logo: "Logo",
        company_dedup_confirm_title: "Merge duplicate companies?",
        company_dedup_confirm_all: "Keep the named company in each group. Delete the other {{count}} records. Career entries will point at the kept company.",
        company_dedup_confirm_group: "Keep \"{{name}}\". Merge and delete the other {{count}} names.",
        company_dedup_running: "Merging companies…",
        company_dedup_done: "Merged {{count}} companies",
        company_dedup_empty: "No mergeable duplicates.",
        company_dedup_skipped: "Skipped — similar names with different LinkedIn company ids",
        company_dedup_load_failed: "Could not load duplicate groups",
        company_dedup_started: "Merge queued",
        company_dedup_finished: "Merge finished",

        // Projects
        projects: "Projects",
        new_project: "New Project",
        no_projects: "No projects yet. Create your first project to get started.",
        project_title: "Project Title",
        project_title_placeholder: "e.g. Project Phoenix",
        edit_project: "Edit project",
        project_status: "Status",
        project_status_potential: "Potential",
        project_status_active: "Active",
        project_status_onHold: "On hold",
        project_status_neverStarted: "Never started",
        project_status_completed: "Completed",
        project_status_closed: "Cancelled",
        project_status_group_live: "Open",
        project_status_group_terminal: "Ended",
        client: "Client",
        select_client: "Select a client",
        role_title: "Role Title",
        role_briefing: "Role Briefing",
        role_briefing_placeholder: "Describe the role requirements...",
        updated_date: "Updated {{date}}",
        not_linked: "Not linked to any projects.",

        // Project pipeline
        pipeline: "Pipeline",
        documents: "Documents",
        settings: "Settings",
        generate_document_btn: "Generate Document",
        project_not_found: "Project not found.",
        project_files: "Project Files",
        upload_file: "Upload File",
        dropzone_title: "Drop files here or click to upload",
        dropzone_hint: "Any file type",
        no_files_uploaded: "No files uploaded yet.",
        file_removed: "File removed",
        document_removed: "Document removed",
        delete_file_failed: "Failed to delete file",
        delete_document_failed: "Failed to delete document",
        n_candidates: "{{count}} candidates",
        tab_status: "Status",
        status_print: "Print",
        status_people_one: "{{count}} person",
        status_people_other: "{{count}} people",
        status_companies_one: "{{count}} company",
        status_companies_other: "{{count}} companies",
        status_subtitle: "Companies looked at, then who declined and why. Expand a company to see who. Print hides names — safe to show the client.",
        status_empty: "Add people to this search. Their current employers will appear here.",
        status_companies_heading: "Companies looked at",
        status_no_companies: "No current employer on file for the people on this search.",
        status_unknown_employer_one: "{{count}} person without a current employer on file",
        status_unknown_employer_other: "{{count}} people without a current employer on file",
        status_reasons_heading: "Who declined",
        status_still_on_search: "Still on the search",
        status_themes_heading: "Themes for the conversation",
        status_no_rejected: "Nobody has been screened out yet. Rejection notes on the pipeline become the groups on this page.",
        status_stale_title: "Reasons have changed",
        status_stale_body: "People have been added or notes edited since this grouping. Group again before the client call.",
        status_grouping: "Grouping reasons…",
        status_grouped: "Reasons grouped",
        status_group_failed: "Could not group the reasons",
        status_group_for_client: "Group reasons for the client",
        status_prepare_reasons: "Prepare reasons",
        status_group_credits: "{{credits}} credits",
        status_label_save_failed: "Could not save the label",
        status_load_failed: "Could not load the status view",

        // Pipeline stages
        stage_identified: "Identified",
        stage_longlist: "Longlist",
        stage_shortlist: "Shortlist",
        stage_interview: "Interview",
        stage_finalist: "Finalist",
        stage_placed: "Placed",
        stage_rejected: "Rejected",
        filter_by_project: "Filter by project…",
        no_candidates_in_stage: "No candidates",
        stage_update_failed: "Failed to update stage",
        ranking_update_failed: "Failed to update ranking",

        // Rejected
        rejected: "Rejected",
        was_stage: "was: {{stage}}",
        restore: "Restore",
        details: "Details",
        search_rejected: "Search rejected...",
        rejected_filter_unattributed: "Not attributed",
        no_rejected_match: "No rejected contacts match your search.",
        add_reason: "Add reason…",
        reason_save_failed: "Failed to save rejection reason",
        reject_candidate: "Reject Candidate",
        reject_reason: "Reason",
        reject_who_initiated: "Who initiated?",
        reject_initiator_placeholder: "Not specified",
        rejection_candidate: "Candidate withdrew",
        rejection_consultant: "We declined",
        rejection_client: "Client rejected",
        rejection_none: "Rejected, not attributed",
        rejection_clerical: "Clerical error (added by mistake)",
        rejection_clerical_help: "Removes the contact from this project entirely. No rejection record is kept; if no other project links them, they will no longer appear as a candidate.",
        remove_from_project: "Remove from project",
        removed: "Removed",
        clerical_removed_msg: "Contact removed from this project.",
        reject_notes: "Notes (optional)",
        reject_notes_placeholder: "Additional context...",
        reject: "Reject",
        reject_failed: "Failed to reject candidate",
        restore_failed: "Failed to restore candidate",

        // Candidate drawer — header, rejection, RHP draft, text sections
        stage_label: "Stage",
        ranking_label: "Ranking",
        no_ranking: "No ranking",
        update_failed: "Failed to update",
        restore_to_pipeline: "Restore to pipeline",
        last_stage: "Last stage: {{stage}}",
        rejection_reason_label: "Rejection reason",
        rejection_reason_placeholder: "Why was this candidate rejected?",
        rejection_reason_saved: "Rejection reason updated",
        no_competency_dimensions: "No competency dimensions configured for this project. Add them in the Settings tab.",
        executive_summary_placeholder: "AI-generated or manually written executive summary of this candidate for the client...",
        personality_notes_placeholder: "Observations about personality, cultural fit, communication style...",
        field_updated: "{{field}} updated",
        field_save_failed: "Failed to save {{field}}",
        approve_failed: "Failed to approve",
        dismiss_failed: "Failed to dismiss remark",
        draft_longlist_hint: "From the CV and profile. Scores not required.",
        draft_assessment_hint: "Needs at least one score. Also refreshes the executive summary and remarks above if they are not approved.",
        remarks_missing_title: "Remarks are still empty",
        remarks_missing_body: "{{count}} of the selected candidates have no remarks yet. Those cells on the longlist will be blank.",
        remarks_missing_create: "Create them now",
        remarks_missing_anyway: "Generate anyway",
        remarks_creating: "Writing remarks…",
        remarks_create_failed: "Could not write remarks for every candidate. Generating the document with what is there.",

        // Add candidate to project
        add_candidate_to_project: "Add Candidate to Project",
        candidate_added: "Candidate added",
        candidate_added_msg: "Candidate added to project",
        add_candidate_failed: "Failed to add candidate",
        already_added: "Already added",
        add_existing_candidate: "Add existing contact",
        bulk_add_from_linkedin: "Add from LinkedIn URLs",
        bulk_add_modal_title: "Add contacts from LinkedIn URLs",
        bulk_add_modal_hint: "Paste LinkedIn profile URLs, one per line. Each URL becomes a contact added to this project at the Identified stage; LinkedIn enrichment runs automatically for new contacts.",
        linkedin_urls_placeholder: "https://www.linkedin.com/in/jane-doe-123/\nhttps://www.linkedin.com/in/john-smith/",
        bulk_done_title: "LinkedIn import complete",
        bulk_result_summary: "{{created}} created, {{addedExisting}} added to project, {{alreadyOnProject}} already on project, {{invalid}} invalid",
        bulk_failed: "LinkedIn import failed",
        add_candidate_dialog_title: "Add contact",
        add_candidate_new: "Add new contact",
        add_candidate_files_hint: "Drop a CV, photo, or vCard (.vcf) for one new contact — the name, contact details, and profile are read from the files.",
        add_candidate_urls_label: "LinkedIn URLs — one per line, one contact each",
        add_candidate_tab_file: "File / CV",
        add_candidate_tab_manual: "Manual",
        add_candidate_added_to_project: "Will be added to “{{project}}”",
        add_candidate_no_files: "Drop or choose a file first.",
        add_candidate_no_urls: "Paste at least one LinkedIn URL.",
        add_candidate_create_many: "Create {{count}} contacts",
        add_candidate_created: "Contact created",
        assign_to_project_optional: "Assign to project (optional)",

        // Project settings
        eval_dimensions: "Evaluation Dimensions",
        eval_dimensions_desc: "Define the competency dimensions used to evaluate candidates in this project. These become the column headers in longlist/shortlist documents.",
        no_dimensions: "No dimensions defined. The system will use defaults during enrichment.",
        add_dimension_placeholder: "Add dimension (e.g., Leadership, Treasury, PE/VC)",
        no_dimensions_alert_title: "No evaluation dimensions yet",
        no_dimensions_alert_body: "Without dimensions, candidates can't be scored, AI drafts have nothing to interpret, and longlist/shortlist documents won't have meaningful columns. Define them now — Leadership, M&A, Treasury, etc.",
        no_dimensions_alert_cta: "Add dimensions",
        search_observations: "Search Observations",
        search_observations_desc: "Market insights and general findings about the search. Included in generated documents.",
        search_observations_placeholder: "e.g., CFO profiles with both PE exit and retail B2C experience are rare in the DACH region...",
        industry_experts: "Industry Experts",
        industry_experts_desc: "Contacts the team interviews to learn the industry for this search. Tagged with the \"Source\" role.",
        no_industry_experts: "No industry experts added.",
        sources_help: "Contacts interviewed for industry insight. They sometimes self-nominate into the search.",
        no_sources: "No sources yet. Add contacts you're using as informants for this search.",
        promote_source_to_candidate: "Move to candidates",
        source_promoted: "Promoted to candidate",
        source_promoted_msg: "Source moved into the pipeline as a candidate.",
        no_candidate_matches: "No matching contacts",
        saved: "Saved",
        project_updated: "Project updated",
        save_failed: "Failed to save",

        // Search
        candidate_search: "Contact Search",
        search_placeholder: "Search contacts...",
        filters: "Filters",
        any_location: "Any location",
        any_skills: "Any skills",
        any_language: "Any language",
        any_tags: "Any tags",
        clear_all: "Clear all",
        try_search: "Try:",
        similar_banner: "Showing candidates similar to the selected profile",
        clear: "Clear",
        results_count: "{{count}} candidate(s) found",

        // Import
        import_candidates: "Import Contacts",
        upload_vcf_zip: "Upload VCF or ZIP",
        import_outlook: "Import from Outlook",
        admin_consent_link: "Get admin-consent link",
        admin_consent_tooltip: "If your Microsoft 365 admin needs to approve the app, get a link to send them",
        import_description: "Upload a .vcf/.zip file, or import contacts directly from your Microsoft 365 Outlook account.",
        no_imports: "No import sessions yet. Upload a file to get started.",
        file: "File",
        type: "Type",
        items: "Items",
        include: "Include",
        files: "Files",
        total: "total",
        imported: "imported",
        skipped: "skipped",
        duplicates: "duplicates",
        ready: "ready",
        check_duplicates: "Check Duplicates",
        import_count: "Import {{count}} Contacts",
        fetching_contacts: "Fetching contacts from Microsoft 365... This may take a few minutes for large contact lists.",
        import_in_progress: "Import in progress... contacts are being created and enrichment jobs queued.",
        import_completed: "Import completed. {{count}} contacts were created.",
        duplicates_found: "{{count}} potential duplicates found",
        matches_existing: "matches existing: {{name}}",
        matches_item: "matches item: {{name}}",

        // Admin tags
        tag_definitions: "Tag Definitions",
        add_tag_title: "Add Tag",
        tag_name_placeholder: "Tag name",
        defined_tags: "Defined Tags ({{count}})",
        no_tags_defined: "No tags defined yet. Add some above.",
        tag: "Tag",
        created: "Created",

        // Navbar
        nav_candidates: "Contacts",
        nav_projects: "Projects",
        nav_clients: "Clients",
        nav_search: "Search",
        nav_documents: "Documents",
        nav_tools: "Tools",
        nav_tasks: "Tasks",
        tasks_page_title: "Tasks",
        tasks_add: "Add task",
        tasks_edit: "Edit task",
        tasks_delete: "Delete task",
        tasks_delete_confirm: "Delete this task? This can't be undone.",
        tasks_title_label: "Title",
        tasks_title_placeholder: "What needs doing?",
        tasks_title_required: "Title is required",
        tasks_notes_label: "Notes",
        tasks_due_date: "Due date",
        tasks_assignee: "Assigned to",
        tasks_unassigned: "Unassigned",
        tasks_important: "Important",
        tasks_quick_today: "Today",
        tasks_quick_tomorrow: "Tomorrow",
        tasks_quick_week: "+1 week",
        tasks_quick_month: "+1 month",
        tasks_client_from_project: "From the linked project",
        tasks_view_list: "List",
        tasks_view_agenda: "Agenda",
        tasks_filter_project: "Filter by project",
        tasks_filter_assignee: "Filter by person",
        tasks_load_more: "Load more",
        tasks_bucket_overdue: "Overdue",
        tasks_bucket_today: "Today",
        tasks_bucket_tomorrow: "Tomorrow",
        tasks_bucket_thisweek: "This week",
        tasks_bucket_later: "Later",
        tasks_bucket_nodate: "No date",
        notifications_title: "Notifications",
        notifications_empty: "You're all caught up.",
        notifications_mark_all_read: "Mark all read",
        notifications_aria: "Notifications",
        tasks_link_project: "Project",
        tasks_link_client: "Client",
        tasks_link_none: "None",
        tasks_overdue: "Overdue",
        tasks_due_today: "Due today",
        tasks_load_failed: "Couldn't load tasks",
        tasks_save_failed: "Couldn't save task",
        tasks_delete_failed: "Couldn't delete task",
        tasks_empty: "No tasks yet. Add the first one.",
        tasks_empty_panel: "No tasks linked here yet.",
        tasks_no_match: "Nothing in this list.",
        tasks_list_myDay: "My Day",
        tasks_list_planned: "Planned",
        tasks_list_important: "Important",
        tasks_list_assigned: "Assigned to me",
        tasks_list_all: "All (team)",
        tasks_list_completed: "Completed",
        tab_tasks: "Tasks",
        nav_activity: "Activity",
        nav_spend_report: "Spend report",
        spend_report_title: "Spend report",
        spend_report_subtitle: "Credits spent across the firm in the last {{n}} days, by action. An audit view — not a bill.",
        spend_last_window: "Last {{n}} days",
        spend_balance: "Current balance",
        spend_credits_unit: "credits",
        spend_by_action: "By action (last {{n}} days)",
        spend_recent: "Recent charges",
        spend_empty: "No credit charges recorded yet.",
        spend_col_action: "Action",
        spend_col_count: "Count",
        spend_col_credits: "Credits",
        spend_col_cost: "Cost",
        spend_col_date: "Date",
        spend_col_detail: "Detail",
        spend_capped: "Showing the latest {{n}} charges.",
        spend_history_note: "The summary covers the last 30 days; the list below shows the latest charges since credit tracking began.",
        spend_action_linkedinFetch: "LinkedIn fetch",
        spend_action_webSearch: "Web search",
        spend_action_cvExtraction: "CV parsing",
        spend_action_compensationExtraction: "Compensation parsing",
        spend_action_consentParse: "Consent parsing",
        spend_action_documentClassification: "Document classification",
        spend_action_transcriptExtraction: "Transcript extraction",
        spend_action_publicDataExtraction: "Public-data extraction",
        spend_action_searchProfile: "Search profile",
        spend_action_searchEmbedding: "Search indexing",
        spend_action_rhpDraft: "Report draft",
        spend_action_transcriptAnalysis: "Transcript analysis",
        spend_action_statusReasons: "Search-status grouping",
        spend_action_other: "Other",
        activity_feed_title: "Team activity",
        activity_feed_subtitle: "Who changed what across your candidates, newest first.",
        activity_feed_empty: "No activity yet.",
        activity_feed_locked_title: "A Pro feature",
        activity_feed_locked_body: "The team activity feed shows who changed what across your candidates — every edit and enrichment, by whom. It's available on the Pro plan.",
        activity_feed_upgrade_cta: "Upgrade to Pro",
        nav_users: "Users",
        nav_tags: "Tags",
        nav_api_keys: "API Keys",
        nav_enrichment: "Enrichment",
        nav_settings: "Settings",

        // Personal preferences (per-user, in the account menu)
        preferences_nav: "Preferences",
        preferences_title: "Preferences",
        preferences_subtitle: "These settings apply only to you.",
        pref_home_title: "Default page",
        pref_home_help: "The page you land on when you open the app.",
        home_page_auto: "Automatic",
        pref_lists_title: "Contact lists",
        pref_lists_help: "Default sorting for contact lists. Alphabetical always sorts by last name and shows names as “Last, First” so the order is easy to follow; the name format applies everywhere else.",
        pref_activity_title: "Activity feed",
        pref_activity_help: "Show the team activity feed in your navigation. Turn it off to hide it — your team keeps the feature.",
        pref_show_activity: "Show activity in navigation",

        // Enrichment settings page
        enrichment_settings: "Enrichment settings",
        default_language: "Default output language",
        default_language_help: "Used for AI-generated text (career summaries, RHP drafts). Projects can override this individually.",
        linkedin_refresh: "LinkedIn refresh",
        auto_linkedin_refresh: "Auto-refresh LinkedIn data in the background",
        linkedin_refresh_days: "Refresh interval (days)",
        max_refresh_per_cycle: "Max candidates per hourly cycle",
        web_search: "Web search",
        auto_web_search: "Include web search during enrichment",
        auto_web_search_on_linkedin_refresh: "Also re-run web search on each LinkedIn refresh",
        auto_web_search_on_linkedin_refresh_help: "Off by default — the periodic refresh stays LinkedIn-only (much cheaper). Web search still runs on import and manual re-enrich.",
        cost_estimate_value: "≈ {{credits}} credits/mo (≈ €{{eur}}/mo)",
        cost_estimate_help: "Approximate recurring cost across {{count}} contacts with a LinkedIn URL, at the current interval. Updates bill at half price; occasional re-embedding (when a profile changes) is extra.",
        cost_estimate_off: "Auto-refresh is off — no recurring cost.",
        settings_saved: "Settings updated",
        output_language: "Output language",
        output_language_help: "Overrides the tenant default for AI-generated text on this project.",
        use_tenant_default: "Use tenant default",

        // API keys
        api_keys_title: "API Keys",
        api_keys_intro: "API keys allow other apps and scripts to access this Veft tenant programmatically — for example, to feed contacts into Monego invoicing.",
        api_keys_list_title: "Active keys",
        api_keys_create_title: "Create API key",
        api_keys_created_title: "API key created",
        api_keys_create_button: "Create key",
        api_keys_one_time_intro: "Your new API key:",
        api_keys_one_time_warning: "This key won't be shown again. Copy it to a secure location.",
        api_keys_name: "Name",
        api_keys_name_placeholder: "Monego invoicing",
        api_keys_permission: "Permission",
        api_keys_rate_limit: "Rate limit (requests/min)",
        api_keys_empty: "No API keys yet.",
        api_keys_unnamed: "Unnamed",
        api_keys_never: "Never",
        api_keys_col_name: "Name",
        api_keys_col_key: "Key",
        api_keys_col_permission: "Permission",
        api_keys_col_last_used: "Last used",

        // MCP endpoint
        api_keys_mcp_title: "Connect an AI agent (MCP)",
        api_keys_mcp_intro:
          "Veft exposes a read-only MCP endpoint, so AI agents like Claude can search candidates, browse projects, and check pipelines. Add it as a custom connector, authenticated with an API key:",
        api_keys_mcp_auth_hint: "Authenticate with the HTTP header",
        copied: "Copied",
        copy: "Copy",
        nav_admin: "Admin",
        nav_tenants: "Tenants",
        nav_jobs: "Jobs",
        nav_admin_users: "Admin Users",

        // Documents page
        document_generation: "Document Generation",
        choose_template: "Choose a template",
        more_templates: "More templates ({{count}})",
        no_templates: "No templates available. Contact your administrator.",
        select_data_sources: "Select data sources",
        project: "Project",
        select_project: "Select a project",
        candidates_selected: "Candidates ({{selected}} of {{total}} selected)",
        no_candidates_on_project: "No candidates on this project yet.",
        enriching_candidates: "Enriching candidates...",
        rendering_document: "Rendering document...",
        generate_document: "Generate Document ({{count}} candidates)",
        generation_started: "Generation started",
        generation_started_message: "Job queued with {{count}} candidates",
        generation_done: "Done",
        generation_done_message: "Document generated successfully",
        generation_failed: "Failed",
        generation_failed_message: "Document generation failed",
        generated_documents: "Generated Documents",
        generated_at: "Generated {{date}}",
        no_generated_documents: "No documents generated yet.",
        unknown_candidate: "Unknown contact",
        no_file_uploaded: "No file uploaded",
        default_template: "Default",
        saving: "Saving…",
        autosave_pending: "Unsaved — will save shortly",
        delete_source_title: "Delete source document",
        delete_source_confirm: "Remove this source from the contact?",
        delete_source_confirm_extracted: "The file will be removed. Career data already taken from it stays on the contact.",
        contact_dropzone_hint: "PDF, Word, or RTF",
        template_purpose_longlist: "Longlist",
        template_purpose_shortlist: "Shortlist",
        template_purpose_detailedCv: "Candidate CV",
        template_purpose_clientPresentation: "Candidate report",
        template_purpose_interviewSummary: "Interview summary",
        template_purpose_referenceCheck: "Reference check",
        template_purpose_rejectedCandidates: "Rejected candidates",
        template_desc_longlist: "Landscape A4. One page per candidate in a structured table layout with bio sidebar, career history, consultant annotations, and competency scores. Bookmarks are placed at each candidate heading for page references.",
        template_desc_shortlist: "Same layout as the longlist, plus a summary table at the top.",
        template_desc_detailedCv: "Portrait A4 résumé. A polished, role-optimized CV in house style. One document per candidate.",
        template_desc_clientPresentation: "Portrait A4 narrative report. Executive summary, per-dimension assessment, personality notes.",
        template_desc_interviewSummary: "Structured interview notes, per-competency observations, and recommendation.",
        template_desc_referenceCheck: "Referee details, structured questions, responses, and overall assessment.",
        template_desc_rejectedCandidates: "Tabular list of rejected or withdrawn candidates, for client check-ins after longlist calibration.",
        template_name_longlist_v1: "Longlist Presentation",
        template_name_shortlist_v1: "Shortlist Report",
        template_name_detailed_cv_v1: "Detailed Candidate CV",
        template_name_client_presentation_v1: "Client Presentation",
        template_name_interview_summary_v1: "Interview Summary",
        template_name_reference_check_v1: "Reference Check",
        template_name_rejected_candidates_v1: "Rejected Candidates List",
        template_name_longlist_typst_v1: "Longlist (Standard)",
        template_name_detailed_cv_typst_v1: "Candidate CV (Standard)",
        template_name_candidate_report_typst_v1: "Candidate Report (Standard)",

        // Search page
        search_button: "Search",
        location_label: "Location",
        skills_label: "Skills",
        languages_label: "Languages",
        tags_label: "Tags",
        candidates_found: "{{count}} candidate(s) found",
        search_semantic_divider: "Similar profiles (semantic matches)",
        search_failed: "Search failed — please try again.",
        search_sort_relevance: "Relevance",
        search_truncated: "Text search stopped at 1,000 matches. Later pages may be incomplete.",

        tools_intro: "Tools that run beside the contact record. Pick a person — no project required.",
        tools_bg_pick: "Search a contact to open the check.",
        tab_background: "Background check",
        bg_title: "Background check",
        bg_intro: "Public-web report: press, mandates, litigation, awards, publications, and a CV consistency check. Informs you; it does not score or decide.",
        bg_when: "Run it whenever you want — longlist, later, or not at all. You choose.",
        bg_start: "Start check",
        bg_cost: "≈ {{credits}} credits ({{price}}) when you confirm the identity.",
        bg_charged_on_confirm: "Identity confirmation is free. Credits are charged only after you confirm this is the right person.",
        bg_resolving: "Building the identity card…",
        bg_gate_help: "Confirm this is the person before any deep search. A wrong identity is the usual failure of a private Google search.",
        bg_gate_question: "Is this the person?",
        bg_confirm: "Yes — run the check",
        bg_reject: "No — wrong person",
        bg_running: "Searching public sources…",
        bg_running_help: "Press, register, litigation, awards, publications, then CV claims. Findings appear as they land.",
        bg_failed: "Check failed",
        bg_failed_generic: "The run failed. You can retry.",
        bg_insufficient_identity: "Not enough to tell this person apart — add a role, employer, location, or LinkedIn URL.",
        bg_insufficient_credits: "Not enough credits for a background check.",
        bg_retry: "Retry",
        bg_rejected_title: "Identity rejected",
        bg_rejected_body: "This run stopped. Start a new check once the contact record is the right person.",
        bg_history: "Earlier checks",
        bg_findings: "Findings",
        bg_claims: "CV consistency",
        bg_no_findings: "No findings that met the evidence rule (verbatim quote + URL).",
        bg_no_claims: "No CV claims were checked.",
        bg_download_pdf: "Download PDF",
        bg_report_disclaimer: "Public, job-relevant sources only. “Not found” is not “cleared”. This report does not score or rank anyone.",
        bg_finding_count: "{{count}} finding(s)",
        bg_load_failed: "Could not load the background check.",
        bg_start_failed: "Could not start the check.",
        bg_confirm_failed: "Could not confirm identity.",
        bg_reject_failed: "Could not reject identity.",
        bg_status_awaitingIdentityConfirmation: "Awaiting confirmation",
        bg_status_running: "Running",
        bg_status_complete: "Complete",
        bg_status_failed: "Failed",
        bg_status_rejected: "Rejected",
        bg_severity_info: "Info",
        bg_severity_noteworthy: "Noteworthy",
        bg_severity_critical: "Critical",
        bg_cat_press: "Press",
        bg_cat_publication: "Publication",
        bg_cat_boardMandate: "Mandate / register",
        bg_cat_litigation: "Litigation",
        bg_cat_insolvency: "Insolvency",
        bg_cat_award: "Award",
        bg_cat_conferenceTalk: "Talk",
        bg_cat_web: "Web",
        bg_verdict_consistent: "Consistent",
        bg_verdict_inconsistent: "Inconsistent",
        bg_verdict_notFound: "Not found",
        bg_claim_tenure: "Tenure",
        bg_claim_title: "Title",
        bg_claim_degree: "Degree",

        // In-app assistant (ChatDrawer)
        assistant_trigger_tooltip: "AI Assistant",
        assistant_trigger_tooltip_locked: "AI assistant — upgrade to Pro",
        assistant_upgrade_prompt: "The AI assistant is available on the Pro plan. Please upgrade to use it.",
        assistant_title: "Assistant",
        assistant_history: "Conversation history",
        assistant_new_conversation: "New conversation",
        assistant_untitled: "Untitled",
        assistant_messages_one: "{{count}} message",
        assistant_messages_other: "{{count}} messages",
        assistant_empty_prompt: "Ask me about your candidates, projects, or pipeline",
        assistant_thinking: "Thinking…",
        assistant_input_placeholder: "Ask a question…",
        assistant_you: "You",
        assistant_copy: "Copy",
        assistant_error: "Sorry, something went wrong. Please try again.",
        assistant_referenced: "Referenced",
        assistant_more: "+{{count}} more",
        assistant_candidate_count_one: "{{count}} candidate",
        assistant_candidate_count_other: "{{count}} candidates",

        // Search — "why was this found" match signals
        search_match_prefix: "Found via",
        search_matched_in: "Matched in {{field}}",
        match_field_name: "name",
        match_field_title: "role",
        match_field_company: "company",
        match_field_skill: "skill",
        match_field_tag: "tag",
        match_field_language: "language",
        match_field_location: "location",
        match_field_summary: "summary",
        match_field_profile: "Matched in profile text",
        match_field_document: "Found in a document",
        match_field_semantic: "Semantic match",
        match_field_fuzzy: "Similar spelling / word form",
        search_fuzzy_divider: "Close matches (spelling & word forms)",
        match_field_similar: "Similar profile",

        // Candidate detail
        edit_profile: "Edit Profile",
        candidate_not_found: "Contact not found.",
        at_company: "at {{company}}",

        // Timeline
        all_filter: "All",
        no_timeline_entries: "No timeline entries.",
        no_entries_of_type: "No timeline entries of this type.",
        activity_transcript: "Transcript",
        show_events: "Show events",

        // Notifications
        error: "Error",

        // AI features
        ai_summary: "AI Summary",
        summary_generated: "Summary generated",
        summary_generated_msg: "AI summary has been created from all available sources.",
        ai_suggest: "AI Suggest",
        ai_suggested_tags_hint: "AI-suggested tags (click to add):",

        // Transcript
        add_transcript: "Add Transcript",
        paste_transcript: "Paste the full transcript here...",
        submit_analyze: "Submit & Analyze",
        transcript_submitted: "Transcript submitted",
        transcript_submitted_msg: "Transcript submitted. Analysis started; enrichment follows in a few minutes.",
        transcript_analysis: "Transcript Analysis",
        analysis_in_progress: "Analysis in progress...",
        insights: "Insights",
        people_mentioned: "People Mentioned",
        add_to_project: "Add to Project",
        added: "Added",
        added_to_project: "Added to project",
        added_to_project_msg: "Candidate added to project",
        linked: "Linked",
        unresolved: "Unresolved",
        analyzed: "Analyzed",
        analyzing: "Analyzing...",

        // Transcript types
        transcript_interview: "Interview",
        transcript_reference: "Reference Call",
        transcript_press: "Press / Media",
        transcript_informal: "Informal",

        // Source types
        source_cv: "CV",
        source_file: "File",
        source_linkedin: "LinkedIn",
        source_web: "Web",
        source_manual: "Manual",
        source_vcf: "VCF",
        source_zip: "ZIP Import",
        source_transcript: "Transcript",
        source_public: "Public",
        source_crmNotes: "Notes",
        source_import: "Import",
        field_sources_title: "Where this data came from",
        field_sources_help: "Each badge shows which source last set that field — hand-entered (Manual), parsed from a CV, fetched from LinkedIn, mined from notes, or filled on import. Manual values are not overwritten by re-enrichment.",

        // Upload / enrichment notifications
        uploaded: "Uploaded",
        upload_success_msg: "Document uploaded. Analysis runs automatically in a few minutes — further uploads are analyzed together. Use re-enrich to run now.",
        upload_failed: "Upload failed",
        enrichment_queued: "Enrichment queued",
        enrichment_queued_msg: "Processing will start shortly",
        reenrich_candidate: "Re-enrich candidate",
        reenrich_explanation: "Re-runs enrichment from CV, LinkedIn and web sources. Skills and notes are merged into existing data.",
        reenrich_cost: "Runs a full enrichment (incl. web search) — about {{credits}} credits ({{price}}). The real charge can be lower when a step has nothing to do.",
        refetch_linkedin_explanation: "Re-fetches the LinkedIn profile only. CV parsing and web search are not re-run.",
        overwrite_career_education: "Replace career and education completely",
        overwrite_career_education_hint: "Career and education are always updated from LinkedIn, but entries someone edited or deleted by hand are kept. Check this to discard those too and take the fetched data as-is.",
        refetch_linkedin: "Refetch LinkedIn",
        linkedin_refetch_queued: "LinkedIn refetch queued",
        linkedin_refetch_queued_msg: "Profile will be re-extracted shortly",

        // Invalid / dead LinkedIn link
        linkedin_invalid_title: "LinkedIn link invalid",
        linkedin_invalid_body: "This LinkedIn profile could not be found (404). The person likely deleted or renamed their profile — even a logged-in visitor would get the same error. Re-fetching won't help: please correct the URL or remove it.",
        linkedin_edit_url: "Edit LinkedIn URL",
        linkedin_edit_url_hint: "Paste the corrected profile URL. Saving a new URL re-runs the LinkedIn fetch.",
        linkedin_try_anyway: "Try anyway",
        linkedin_mark_invalid: "Mark link invalid",
        linkedin_marked_invalid: "Link marked invalid",
        linkedin_marked_invalid_msg: "The LinkedIn link is flagged invalid and will no longer be re-fetched automatically.",

        // LinkedIn identity mismatch (fetch held by the name gate)
        linkedin_mismatch_title: "LinkedIn profile doesn't match this contact",
        linkedin_mismatch_body: "The profile behind the stored URL is named “{{profileName}}”, which doesn't match {{candidateName}}, so nothing was imported. If it is the same person anyway (name change, different spelling), apply the profile. Otherwise correct or remove the URL.",
        linkedin_mismatch_accept: "Same person — apply profile",
        linkedin_mismatch_reject: "Wrong profile — remove URL",
        linkedin_mismatch_removed: "LinkedIn URL removed",
        linkedin_mismatch_removed_msg: "The URL is gone; nothing from that profile was imported.",
        linkedin_slug_warning: "This URL looks like it belongs to “{{slugName}}”, not to {{candidateName}}. Double-check it before saving.",

        // Avatar
        photo_edit: "Change photo",
        photo_upload: "Upload photo",
        photo_remove: "Remove photo",
        photo_updated: "Photo updated",
        photo_updated_msg: "The new photo is saved.",
        photo_removed: "Photo removed",
        photo_removed_msg: "The photo was removed. A LinkedIn refetch may load the profile's current picture again.",

        // Languages editor
        done: "Done",
        select_languages: "Select languages...",

        // Delete notifications
        deleted_notification: "Deleted",
        candidate_deleted_msg: "{{name}} has been deleted",

        // Plans / billing page
        plans_title: "Plans & billing",
        plans_subtitle: "Pick the plan that fits your search workload. Credits power enrichment, drafting and search.",
        plans_current_badge: "Current plan: {{plan}}",
        plans_interval_monthly: "Monthly",
        plans_interval_annual: "Annual (2 months free)",
        plans_per_month: "/ month",
        plans_billed_yearly: "{{currency}}{{amount}} billed yearly",
        plans_lets_talk: "Let's talk",
        plans_free: "Free",
        plans_most_popular: "Most popular",
        plans_cta_included: "Included",
        plans_cta_current: "Current plan",
        plans_cta_choose: "Choose {{name}}",
        plans_cta_subscribe: "Subscribe to {{name}}",
        plans_cta_manage: "Manage subscription",
        plans_cta_contact: "Contact sales",
        plans_cta_contact_current: "Current — contact us",
        plans_checkout_failed: "Checkout failed",
        plans_portal_failed: "Could not open billing portal",
        plans_footer_more_credits: "Need more credits on Pro?",
        plans_footer_buy_packs: "Buy credit packs",
        plans_footer_questions: "Questions?",
        plans_footer_contact_us: "Contact us",
        // Shared feature labels (reused across tiers)
        plans_feat_bulk_import: "Bulk folder/ZIP import",
        plans_feat_ai_api: "AI assistant & API access",
        plans_feat_custom_templates: "Custom DOCX templates",
        // Trial tier
        plans_trial_blurb: "Kick the tyres — 750 credits, 14 days.",
        plans_trial_feat_candidates: "50 candidates",
        plans_trial_feat_user: "1 user",
        plans_trial_feat_cv: "Single CV import + enrichment",
        plans_trial_feat_buy_credits: "Buy additional credits",
        // Pro tier
        plans_pro_blurb: "For active search work. 33,000 credits / month.",
        plans_pro_feat_candidates: "6,000 candidates",
        plans_pro_feat_users: "3 users",
        plans_pro_feat_buy_credits: "Buy additional credits anytime",
        // Enterprise tier
        plans_enterprise_blurb: "Custom limits, custom templates, SSO & priority support.",
        plans_ent_feat_unlimited: "Unlimited candidates",
        plans_ent_feat_seats: "Custom user seats",
        plans_ent_feat_sso: "SSO & priority support",
        plans_ent_feat_credits: "Custom credit allotment",

        // Consent settings page (/settings/consent)
        consent_settings_title: "GDPR consent",
        consent_settings_disclaimer: "The template below is a sample. You are responsible for the legal content and for identifying the correct data controller. Veft provides the mechanism, not legal wording.",
        consent_settings_request_template: "Request template",
        consent_settings_tpl_name: "Name",
        consent_settings_tpl_language: "Language",
        consent_settings_tpl_validity: "Default validity",
        consent_settings_tpl_subject: "Subject",
        consent_settings_tpl_body: "Body",
        consent_settings_placeholders_label: "Placeholders:",
        consent_settings_controller_microsite: "Controller & microsite",
        consent_settings_controller_identity: "Data controller identity",
        consent_settings_controller_identity_desc: "Shown on the review page. Falls back to your tenant name when empty.",
        consent_settings_microsite_footer: "Microsite footer",
        consent_settings_accent_color: "Accent color (hex)",
        consent_settings_timing_retention: "Timing & retention",
        consent_settings_link_validity: "Link valid for (days)",
        consent_settings_overdue_after: "Overdue after (days)",
        consent_settings_remind_after: "Remind after (days, 0 = off)",
        consent_settings_minimize_label: "Minimize consent proof on erasure",
        consent_settings_minimize_desc: "Off (recommended): consent proof is retained when a candidate is deleted, because the record is your evidence of compliance. On: PII in the proof is redacted on erasure (chain stays verifiable by linkage).",
        consent_settings_save: "Save",
        consent_settings_verify_chain: "Verify chain integrity",
        consent_settings_chain_intact: "Chain intact",
        consent_settings_chain_broken: "Broken at #{{seq}}",
        consent_settings_saved: "Saved",
        consent_settings_save_error: "Could not save consent settings",
        consent_activation_title: "Activation",
        consent_activation_desc: "Sending is locked until you activate it — a safeguard so the example template is never sent to a real contact.",
        consent_activation_switch: "Activate consent sending",
        consent_activation_status_on: "Active",
        consent_activation_status_off: "Locked",
        consent_activation_placeholder_warning: "Your template still contains the example text (\"BEISPIELTEXT\"). Replace it with your own wording to activate.",
        consent_test_send_button: "Send myself a test",
        consent_test_send_sent: "Test email sent to {{email}} — check your inbox, then click the link to try the flow.",
        consent_test_send_error: "Could not send the test email",
        consent_validity_months6: "6 months",
        consent_validity_months12: "12 months",
        consent_validity_months24: "24 months",
        consent_validity_indefinite: "Indefinite",

        // Data export (GDPR) page (/settings/export)
        export_nav: "Data export",
        export_title: "Data export (GDPR)",
        export_intro: "Download a complete copy of this account's data — every contact (as a vCard plus their attachments and structured data), your projects, clients, evaluations and the consent history — as a single ZIP file.",
        export_retention_note: "The finished file contains personal data. It is kept for 7 days and then deleted automatically.",
        export_create_heading: "Create a new export",
        export_start: "Start export",
        export_running_hint: "Preparing your export. This can take a few minutes for large accounts — you can leave this page, it keeps running.",
        export_history: "Your exports",
        export_empty: "No exports yet.",
        export_col_created: "Created",
        export_col_contacts: "Contacts",
        export_col_size: "Size",
        export_col_expires: "Available until",
        export_expired: "Expired",
        export_download: "Download",
        export_started: "Export started",
        export_started_msg: "Your export is being prepared.",
        export_ready: "Export ready",
        export_ready_msg: "Your data is ready to download.",
        export_failed: "Export failed",
        export_failed_msg: "The export could not be completed. Please try again.",
        export_already_running: "An export is already running for this account.",

        // --- Onboarding / contextual help (InfoHint + empty states) ---
        // Convention: _hint = short inline line · _help = multi-line popover/Alert · _tooltip = one-line hover.
        // Always add the matching German twin in the de.Veft block in the same edit.
        add_candidate_enrich_note: "When you add a contact, enrichment runs automatically.",
        enrichment_intake_help: "Adding a contact starts enrichment in the background: we read any uploaded CV, fetch the LinkedIn profile if a URL is given, and run a web search. It takes a few minutes and uses credits. Results appear on the contact's profile.",
        add_candidate_est_cost: "Estimated cost",
        add_candidate_est_value_one: "≈ {{credits}} credits ({{price}})",
        add_candidate_est_value_many: "≈ {{credits}} credits for {{count}} contacts ({{price}})",
        add_candidate_est_balance: "Balance: {{balance}} credits",
        add_candidate_est_hint: "Rough estimate — the real cost depends on what each contact needs.\n\nTypical rates: CV parse {{cv}}, LinkedIn fetch {{li}}, web search {{web}}, search index {{idx}} credits.\n\nWeb search only runs when it's enabled and the contact has enough context, so the actual cost is often lower. 1,000 credits ≈ {{price1k}}.",
        company_field_help: "Search known companies. Matching one links this contact to others there and enriches company data — or just type a name freely if there's no match.",
        enrichment_what_help: "Enrichment automatically fills in career, education, skills and location by reading uploaded documents, the LinkedIn profile and a web search. It runs in the background when you add a contact, upload a document, or click Re-enrich — and it uses credits.",
        enrich_status_none: "Not started",
        enrich_status_pending: "Queued",
        enrich_status_extracting: "Reading documents",
        enrich_status_parsing: "Analysing with AI",
        enrich_status_embedding: "Indexing for search",
        enrich_status_complete: "Up to date",
        enrich_status_failed: "Failed",
        enrichment_failed_help: "Enrichment couldn't finish. Try Re-enrich, or check that the LinkedIn URL is correct.",
        enrich_web_nocontext_help: "Web search needs at least a job title or company to find the right person (so it doesn't pick the wrong namesake). Add a title or company above, then Re-enrich.",
        contacts_empty_title: "No contacts yet",
        contacts_empty_help: "Contacts are the people in your database. Add one manually, paste a LinkedIn URL, or import a file — each is enriched automatically.",
        projects_empty_title: "No projects yet",
        projects_empty_help: "A project is one search for a client. Pick a client and a target role to start a pipeline.",
        clients_empty_title: "No clients yet",
        clients_empty_help: "Clients are the companies you run searches for. Add one to create projects against it.",
        roles_help: "Roles mark how you work with a contact:\n• Candidate — in a search pipeline\n• Client — works at a hiring company\n• Reference — vouches for a candidate\n• Source — helps you find candidates\n• Identified — spotted, not yet approached\n• Potential — interesting for future searches",
        pipeline_stages_help: "Stages track where each contact stands in this search:\n• Identified — new lead\n• Longlist — meets the basics\n• Shortlist — strong fit\n• Interview — in conversation\n• Finalist — final round\n• Placed — hired\n• Rejected — not proceeding\nDrag a card to move it between stages.",
        consent_states_help: "Consent controls whether you may use a person's data in documents and pitches:\n• Granted — you may use it\n• Requested / Not requested — not yet\n• Declined / Withdrawn — you must stop\n• Expired — ask again\n• Overdue — requested but no reply yet\n• Won't ask — you've chosen not to request consent",
      },
      // Legacy namespace — Boilerplate components reference "translation:..."
      translation: {},
    },
    de: {
      common: {
        generic: {
          first_name: "Vorname",
          last_name: "Nachname",
          email: "E-Mail",
          role: "Rolle",
          logout: "Abmelden",
          action_save: "Speichern",
          confirm: "Bestätigen",
          cancel: "Abbrechen",
          confirm_title: "Sind Sie sicher?",
          action_irreversible: "Diese Aktion kann nicht rückgängig gemacht werden.",
        },
        settings: {
          profile: "Profil",
          organization_settings: "Organisationseinstellungen",
          changes_saved: "Änderungen gespeichert",
          changes_saved_message: "Ihre Profiländerungen wurden gespeichert",
          change_password: "Passwort ändern",
          set_password: "Passwort setzen",
          password: "Passwort",
          appearance: "Erscheinungsbild",
          appearance_description: "Wählen Sie ein Design für die Oberfläche. „System“ übernimmt die Einstellung Ihres Geräts.",
          theme_light: "Hell",
          theme_dark: "Dunkel",
          theme_system: "System",
          sessions: "Sitzungen",
          sessions_user_agent: "Browser / Gerät",
          sessions_ip_address: "IP-Adresse",
          sessions_issued_at: "Angemeldet am",
          sessions_expires_at: "Läuft ab am",
          session_deleted_title: "Sitzung gelöscht",
          session_deleted_message: "Die Sitzung wurde gelöscht.",
        },
        tenant: {
          settings_title: "Einstellungen",
          org_name_label: "Organisationsname",
          org_name_placeholder: "ACME GmbH",
          profile_updated_title: "Profil aktualisiert",
          profile_updated_message: "Ihr Organisationsprofil wurde aktualisiert",
          credits_title: "Credits",
          buy_credits: "Credits kaufen",
          auto_refill_title: "Automatische Auffüllung",
          auto_refill_desc: "Füllen Sie Ihre Credits in jedem Abrechnungszyklus automatisch auf einen festgelegten Schwellenwert auf. Nur mit aktivem Abonnement verfügbar.",
          auto_refill_updated_title: "Automatische Auffüllung aktualisiert",
          auto_refill_updated_message: "Ihre Einstellungen zur automatischen Auffüllung wurden gespeichert",
          auto_refill_disabled_title: "Automatische Auffüllung deaktiviert",
          auto_refill_disabled_message: "Die automatische Auffüllung wurde deaktiviert",
          refill_threshold_label: "Auffüll-Schwellenwert",
          refill_threshold_placeholder: "Ziel-Guthaben eingeben",
          refill_threshold_desc: "Ihr Guthaben wird in jedem Abrechnungszyklus auf diesen Wert aufgefüllt",
          credit_type_label: "Credit-Typ",
          credit_type_desc: "Welcher Credit-Typ aufgefüllt werden soll",
          credit_type_default: "Standard",
          save_auto_refill: "Auto-Auffüllung speichern",
          disable_auto_refill: "Auto-Auffüllung deaktivieren",
          users_title: "Benutzer",
          manage_users: "Benutzer verwalten",
          subscription_title: "Abonnement",
          current_plan: "Aktueller Tarif:",
          no_subscription: "Sie haben derzeit kein aktives Abonnement",
          manage_subscription: "Abonnement verwalten",
          create_subscription: "Abonnement abschließen",
          api_keys_title: "API-Schlüssel",
          api_key_create_new: "Neuen Schlüssel erstellen",
          api_key_modal_title: "API-Schlüssel",
          api_key_col_name: "Name",
          api_key_col_brand: "Marke",
          api_key_col_last4: "Letzte 4",
          api_key_col_issued: "Ausgestellt",
          api_key_col_last_used: "Zuletzt verwendet",
          api_key_col_expires: "Läuft ab",
          api_key_all_brands: "Alle",
          api_key_deleted: "API-Schlüssel gelöscht",
          api_key_new_intro: "Ihr neuer API-Schlüssel:",
          api_key_copy: "API-Schlüssel kopieren",
          api_key_copied: "In die Zwischenablage kopiert",
          api_key_security_warning: "Dieser Schlüssel kann nicht erneut angezeigt werden! Bitte kopieren Sie ihn an einen sicheren Ort. Geben Sie den Schlüssel an niemanden weiter — er gewährt vollständigen Zugriff auf Ihr Konto!",
          api_key_scope: "Geltungsbereich",
          api_key_scope_account: "Alle Marken (Konto)",
          api_key_scope_brand: "Einzelne Marke",
          api_key_brand_label: "Marke",
          api_key_brand_placeholder: "Marke auswählen",
          api_key_account_alert_title: "Kontoweiter Schlüssel",
          api_key_account_alert_msg: "Dieser Schlüssel hat Zugriff auf alle Marken in Ihrem Konto, einschließlich zukünftig hinzugefügter.",
          api_key_brand_alert_title: "Markenspezifischer Schlüssel",
          api_key_brand_alert_msg: "Dieser Schlüssel hat nur Zugriff auf {{brandName}}.",
          api_key_name_label: "Name",
          api_key_name_desc: "Ein optionaler Name, um Schlüssel zu unterscheiden",
          api_key_name_placeholder: "Mein Test-Schlüssel",
          api_key_create: "Erstellen",
          security_title: "Sicherheit",
          security_updated_title: "Sicherheitseinstellungen aktualisiert",
          require_passkey_label: "Anmeldung per Passkey erforderlich",
          require_passkey_desc:
            "Jedes Mitglied muss sich mit einem Passkey anmelden. Mitglieder, die noch keinen haben, werden bei der nächsten Anmeldung aufgefordert, einen zu erstellen; die Anmeldung allein mit Passwort wird dann abgelehnt. Stellen Sie sicher, dass Sie auf Ihrem Gerät einen Passkey erstellen können, bevor Sie diese Option aktivieren.",
          require_passkey_on_msg:
            "Die Anmeldung per Passkey ist jetzt für alle Mitglieder erforderlich.",
          require_passkey_off_msg:
            "Die Anmeldung per Passkey ist nicht mehr erforderlich.",
        },
        passkey_required_title: "Passkey einrichten",
        passkey_required_body:
          "Ihre Organisation erfordert die Anmeldung per Passkey. Erstellen Sie jetzt einen Passkey, um fortzufahren – Sie verwenden ihn ab sofort für die Anmeldung.",
        passkey_create: "Passkey erstellen",
        sign_out: "Abmelden",
        passkey_cancelled:
          "Die Passkey-Einrichtung wurde abgebrochen oder ist auf diesem Gerät nicht verfügbar.",
        passkey_enrolled: "Passkey erstellt – Sie sind startklar.",
        passkey_enroll_error: "Passkey konnte nicht erstellt werden",
      },
      Auth: {
        name_placeholder: "Max Mustermann",
        email_placeholder: "max@beispiel.de",
        register: "Registrieren",
        name: "Name",
        current_password: "Aktuelles Passwort",
        new_password: "Neues Passwort",
        change_password: "Passwort ändern",
        title: "Bei Veft anmelden",
        invalid_email: "Ungültige E-Mail-Adresse",
        invalid_password: "Das Passwort muss mindestens 8 Zeichen enthalten",
        login_failed: "Anmeldung fehlgeschlagen",
        incorrect_user_or_password: "Falscher Benutzername oder falsches Passwort",
        rate_limit_exceeded: "Zu viele Anmeldeversuche. Bitte versuchen Sie es später erneut.",
        unexpected_error: "Ein unerwarteter Fehler ist aufgetreten: ",
        email: "E-Mail",
        password: "Passwort",
        your_password: "Ihr Passwort",
        forgot_password: "Passwort vergessen?",
        login: "Anmelden",
        you_are_logged_in: "Sie sind angemeldet",
        password_reset_requested: "Passwort-Zurücksetzung angefordert",
        password_reset_requested_message:
          "Bitte prüfen Sie Ihre E-Mail und folgen Sie dem Link zum Zurücksetzen Ihres Passworts.",
        recover_password: "Passwort wiederherstellen",
        request_reset_email: "Wiederherstellungs-E-Mail senden",
        login_instead: "Stattdessen anmelden",
        passkey_required_login:
          "Ihre Organisation erfordert die Anmeldung per Passkey. Bitte melden Sie sich mit Ihrem Passkey an.",
      },
      Users: {
        add_user: "Benutzer hinzufügen",
        email: "E-Mail",
        first_name: "Vorname",
        last_name: "Nachname",
        role: "Rolle",
        created: "Erstellt",
        is_active: "Aktiv",
        user_deleted: "Benutzer gelöscht!",
        invite_user: "Benutzer einladen",
        invitation_sent: "Einladung gesendet!",
        invite_user_info:
          "Dies sendet eine Einladung an den Benutzer, damit er Ihnen beitreten kann.",
        save: "Speichern",
        edit: "Bearbeiten",
        delete: "Löschen",
        details: "Details",
        versions: "Versionen",
        reset_passkeys: "Passkeys zurücksetzen",
        reset_passkeys_confirm:
          "Passkeys dieses Benutzers zurücksetzen? Er meldet sich dann mit seinem Passwort an und wird aufgefordert, einen neuen Passkey zu erstellen. Verwenden Sie dies, um ein verlorenes oder gestohlenes Gerät wiederherzustellen.",
        reset_passkeys_done_title: "Passkeys zurückgesetzt",
        reset_passkeys_done_msg:
          "Der Benutzer kann sich jetzt mit seinem Passwort anmelden und einen neuen Passkey registrieren.",
        reset_passkeys_error_title: "Passkeys konnten nicht zurückgesetzt werden",
      },
      FIDO: {
        fidoKey: {
          registeredSuccess: "Passkey erfolgreich registriert",
          keyAdded: "Ihr Passkey wurde hinzugefügt",
          fetchError: "Fehler beim Abrufen der Passkeys",
          deletedSuccess: "Passkey erfolgreich gelöscht",
          keyRemoved: "Passkey entfernt",
          deleteError: "Fehler beim Löschen des Passkeys",
          lastUsed: "Zuletzt verwendet",
          created: "erstellt",
          actions: {
            add: "Passkey hinzufügen",
            remove: "Passkey entfernen",
          },
          title_passkeys: "Passkeys",
        },
        registerError: "Fehler bei der Passkey-Registrierung",
      },
      Veft: {
        // Shared
        name: "Name",
        title: "Titel",
        location: "Standort",
        email: "E-Mail",
        phone: "Telefon",
        industry: "Branche",
        save: "Speichern",
        cancel: "Abbrechen",
        add: "Hinzufügen",
        create: "Erstellen",
        delete: "Löschen",
        back: "Zurück",
        search: "Suchen",
        tags: "Tags",
        status: "Status",
        date: "Datum",
        no_data: "—",

        // Candidates (UI-Bezeichnung: Kontakte; Backend-Entity bleibt Candidate)
        candidates: "Kontakte",
        profiles_count: "{{count}} Profile",
        add_candidate: "Kontakt hinzufügen",
        search_candidates: "Kontakte nach Name suchen...",
        no_candidates: "Keine Kontakte gefunden.",
        sort_label: "Sortierung",
        sort_recent: "Neueste",
        sort_alpha: "Alphabetisch",
        name_format_label: "Namensformat",
        name_format_first_last: "Vorname Nachname",
        name_format_last_first: "Nachname, Vorname",
        current_role: "Aktuelle Position",
        open_to_work: "Wechselbereit",
        updated_ago: "Aktualisiert {{ago}}",
        consent: "Einwilligung",
        filter: "Filter",
        call: "Anrufen",
        send_email: "E-Mail",
        filter_by_consent: "Nach Einwilligung filtern",
        consent_status_notRequested: "Nicht angefragt",
        consent_status_requested: "Angefragt",
        consent_status_overdue: "Überfällig",
        consent_status_granted: "Erteilt",
        consent_status_declined: "Abgelehnt",
        consent_status_expired: "Abgelaufen",
        consent_status_withdrawn: "Widerrufen",
        consent_status_suppressed: "Nicht anfragen",
        consent_manage: "Einwilligung verwalten",
        consent_send_request: "Einwilligung anfragen",
        consent_no_email_warning: "Dieser Kontakt hat keine E-Mail-Adresse, daher kann keine Einwilligungsanfrage gesendet werden. Fügen Sie eine E-Mail-Adresse hinzu oder erfassen Sie die Einwilligung unten manuell.",
        consent_not_activated_warning: "Der Einwilligungsversand ist noch nicht aktiviert. Prüfen Sie die Vorlage und aktivieren Sie ihn unter Einstellungen → Einwilligung, bevor Sie Anfragen senden.",
        consent_event_requestCreated: "Anfrage erstellt",
        consent_event_requestSent: "Anfrage gesendet",
        consent_event_requestResent: "Anfrage erneut gesendet",
        consent_event_requestViewed: "Anfrage angesehen",
        consent_event_approved: "Zugestimmt",
        consent_event_declined: "Abgelehnt",
        consent_event_withdrawn: "Widerrufen",
        consent_event_expired: "Abgelaufen",
        consent_event_requestRevoked: "Anfrage zurückgezogen",
        consent_event_markedNotRequired: "Als nicht erforderlich markiert",
        consent_event_offlineConsentRecorded: "Offline-Einwilligung erfasst",
        consent_event_suppressionSet: "Auf „Nicht anfragen“ gesetzt",
        consent_event_suppressionCleared: "„Nicht anfragen“ aufgehoben",
        consent_actor_staff: "Mitarbeiter",
        consent_actor_subject: "Betroffene Person",
        consent_actor_system: "System",
        consent_resend: "Erneut senden",
        consent_revoke: "Zurückziehen",
        consent_pending_sent_to: "Ausstehend — gesendet an {{email}}",
        consent_timeline: "Verlauf",
        consent_no_history: "Noch keine Einwilligungs-Aktivität.",
        consent_record_offline: "Offline-Einwilligung erfassen",
        consent_mark_not_required: "Als \"nicht anfragen\" markieren",
        consent_clear_suppression: "\"Nicht anfragen\" aufheben",
        consent_suppress_reason: "Grund (optional)",
        consent_download_certificate: "Nachweis",
        consent_validity: "Gültigkeit",
        consent_until: "bis",
        consent_indefinite: "unbefristet",
        consent_requests: "Anfragen",
        consent_save: "Speichern",
        full_name: "Vollständiger Name",
        first_name: "Vorname",
        last_name: "Nachname",
        last_name_required: "Nachname ist erforderlich",
        title_placeholder: "z.B. Geschäftsführer",
        company_placeholder: "z.B. Siemens AG",
        location_placeholder: "z.B. Berlin, Deutschland",
        location_search_placeholder: "Stadt oder Land suchen…",
        geo_type_place: "Stadt",
        geo_type_region: "Region",
        geo_type_country: "Land",
        geo_radius_label: "Umkreis",
        geo_radius_exact: "Nur dieser Ort",
        geo_radius_option: "+{{km}} km",
        geo_lookup_failed: "Ort konnte nicht geladen werden",
        filter_location_chip: "Standort: {{place}}",
        filter_location_chip_radius: "Standort: {{place}} +{{km}} km",
        search_place_chip: "Nur Kontakte in {{place}} anzeigen",
        search_place_chip_dismiss: "Vorschlag ausblenden",
        view_list: "Liste",
        view_list_aria: "Listenansicht",
        view_map: "Karte",
        view_map_aria: "Kartenansicht",
        map_no_location_badge_one: "{{count}} Kontakt ohne Standortdaten",
        map_no_location_badge_other: "{{count}} Kontakte ohne Standortdaten",
        map_capped_hint: "Zeigt die {{count}} zuletzt aktualisierten Kontakte",
        map_empty: "Keine Kontakte mit Standortdaten für diese Filter",
        map_error: "Die Karte konnte nicht geladen werden",
        map_retry: "Erneut versuchen",
        map_not_configured: "Die Kartenansicht ist in dieser Umgebung nicht konfiguriert",
        email_placeholder: "email@beispiel.de",
        phone_placeholder: "+49 ...",
        linkedin_url: "LinkedIn-URL",
        enrichment_failed: "Anreicherung fehlgeschlagen",
        enrichment_error: "Letzter Fehler",
        enriching: "Wird angereichert...",
        no_role_info: "Keine Positionsangabe",
        trash: "Papierkorb",
        import: "Importieren",
        find_similar: "Ähnliche finden",
        more_actions: "Weitere Aktionen",
        delete_candidate: "Kontakt löschen",
        delete_confirm: "Möchten Sie {{name}} wirklich löschen? Dies kann innerhalb von 30 Tagen rückgängig gemacht werden.",
        gdpr: "DSGVO: {{status}}",

        // Deleted candidates (trash)
        deleted_candidates_title: "Gelöschte Kontakte",
        deleted_candidates_count: "{{count}} im Papierkorb",
        deleted_candidates_retention: "Gelöschte Kontakte werden nach 30 Tagen endgültig entfernt.",
        deleted_candidates_empty: "Der Papierkorb ist leer.",
        deleted_col_deleted: "Gelöscht",
        deleted_col_purge: "Automatische Löschung",
        deleted_purge_days_one: "in {{count}} Tag",
        deleted_purge_days_other: "in {{count}} Tagen",
        deleted_purge_imminent: "Steht bevor",
        restore_success_title: "Wiederhergestellt",
        restore_success_msg: "{{name}} wurde wiederhergestellt",
        deleted_restore_failed: "Wiederherstellung fehlgeschlagen",

        // Candidate profile tabs
        tab_timeline: "Aktivität",
        imported_note_outlook: "Importierte Notiz (Outlook)",
        read_only: "schreibgeschützt",
        remove: "Entfernen",
        tab_summary: "Zusammenfassung",
        tab_career: "Karriere",
        tab_notes: "Notizen",
        tab_tags: "Tags",
        tab_documents: "Dokumente",
        tab_projects: "Projekte",

        // Key facts
        key_facts: "Eckdaten",
        phone_numbers: "Telefonnummern",
        metadata: "Metadaten",
        languages: "Sprachen",
        skills: "Fähigkeiten",
        add_skill: "Fähigkeit hinzufügen...",
        enrichment: "Anreicherung",
        sources: "Sources",
        documents_count: "{{count}} Dokumente",
        gdpr_consent: "DSGVO-Einwilligung",
        timeline_entries: "Verlaufseinträge",
        last_interaction: "Letzter Kontakt",
        first_contact: "Erster Kontakt",
        show_less: "weniger anzeigen",
        show_more: "mehr anzeigen",

        // Phone numbers
        phone_label: "Telefon:",
        add_phone: "Telefonnummer hinzufügen",
        phone_number: "Telefonnummer",
        phone_mobile: "Mobil",
        phone_mobilePrivate: "Mobil (privat)",
        phone_office: "Büro",
        phone_home: "Privat",

        // Emails
        email_label: "E-Mail:",
        add_email: "E-Mail hinzufügen",
        email_address: "E-Mail-Adresse",
        email_business: "Geschäftlich",
        email_personal: "Privat",
        primary: "Primär",
        make_primary: "Als primär setzen",

        // Postanschriften (strukturiert, getrennt vom freien Standort-Feld)
        addresses_label: "Anschriften:",
        add_address: "Anschrift hinzufügen",
        address_business: "Geschäftlich",
        address_personal: "Privat",
        address_other: "Sonstige",
        address_line1: "Straße und Hausnummer",
        address_line2: "Zusatz / c/o (optional)",
        address_postal_code: "PLZ",
        address_city: "Stadt",
        address_region: "Bundesland / Region",
        address_country: "Land",

        // Compensation
        compensation: "Vergütung",
        comp_total: "Gesamt:",
        comp_base: "Grundgehalt:",
        comp_note: "Anmerkung:",
        comp_as_of: "Stand {{date}}",
        comp_breakdown: "Aufschlüsselung",
        comp_currency: "Währung",
        comp_add: "Vergütung hinzufügen",
        comp_remove: "Entfernen",
        comp_manual: "manuell erfasst",
        comp_note_placeholder: "z. B. telefonisch genannt; erwartet ca. 15 % Steigerung",
        comp_breakdown_preserved: "Die strukturierte Aufschlüsselung aus dem Dokument bleibt erhalten.",
        comp_kind_base: "Grundgehalt",
        comp_kind_bonus: "Bonus",
        comp_kind_commission: "Provision",
        comp_kind_ltip: "LTIP",
        comp_kind_equity: "Beteiligung",
        comp_kind_allowance: "Zulage",
        comp_kind_pension: "Altersvorsorge",
        comp_kind_oneTime: "Einmalzahlung",
        comp_kind_other: "Sonstiges",
        comp_period_monthly: "Monat",
        comp_period_annual: "Jahr",
        comp_period_oneTime: "einmalig",
        // Document kind (content classification of an uploaded document)
        doc_kind_cv: "Lebenslauf",
        doc_kind_compensation: "Vergütung",
        doc_kind_consentForm: "Einwilligung",
        doc_kind_other: "Dokument",

        // Summary
        summary: "Zusammenfassung",
        no_summary: "Keine Zusammenfassung vorhanden.",
        notes: "Notizen",
        no_notes: "Keine Notizen.",
        notes_imported_hint: "Aus der Kontaktkarte importiert. Strukturierte Daten (Vergütung, LinkedIn) werden hieraus automatisch extrahiert.",
        credits_remaining_tooltip: "{{credits}} Credits übrig",
        // Import page (/candidates/import)
        import_title: "Kandidaten importieren",
        import_subtitle: "Laden Sie eine .vcf-/.zip-Datei hoch oder importieren Sie Kontakte direkt aus Ihrem Microsoft-365-Outlook-Konto.",
        import_upload_button: "VCF oder ZIP hochladen",
        import_limit_all: "Alle",
        import_from_outlook: "Aus Outlook importieren",
        import_admin_consent_tooltip: "Falls Ihr Microsoft-365-Administrator die App freigeben muss, erhalten Sie hier einen Link zum Weiterleiten",
        import_get_admin_consent: "Admin-Einwilligungslink abrufen",
        import_admin_consent_title: "Admin-Einwilligungslink",
        import_admin_consent_body: "Leiten Sie diesen Link an Ihren Microsoft-365-Administrator weiter. Dieser meldet sich mit seinem Administratorkonto an und klickt auf <b>Akzeptieren</b>, um Veft zu autorisieren, Kontakte für Benutzer in Ihrem Mandanten zu lesen. Führen Sie anschließend den regulären Outlook-Import durch.",
        import_copied: "Kopiert",
        import_copy_link: "Link kopieren",
        import_open_new_tab: "In neuem Tab öffnen",
        import_zip_upgrade: "Der Massen-Import von Ordnern/ZIPs ist im Pro-Tarif verfügbar. Bitte führen Sie ein Upgrade durch, um Kandidaten-Archive zu importieren.",
        import_zip_help_title: "So strukturieren Sie eine ZIP-Datei für den Import",
        import_zip_help_intro: "Jeder Kandidat ist <b>ein Ordner auf oberster Ebene</b> in der ZIP-Datei. Legen Sie die Kandidatenordner in das Stammverzeichnis des Archivs — verschachteln Sie sie nicht alle in einem einzigen übergeordneten Ordner.",
        import_zip_tree_optional: "← optional",
        import_zip_tree_contact: "← optional (E-Mail, Telefon, Titel…)",
        import_zip_help_footnote: "Ebenfalls unterstützt: eine einzelne <b>.vcf mit mehreren Kontakten</b> → ein Kandidat pro Kontakt, sowie lose Lebenslauf-Dateien auf oberster Ebene → ein Kandidat pro Datei. Ein versehentlich umschließender übergeordneter Ordner wird automatisch erkannt und entpackt, aber ein flaches Layout ist am zuverlässigsten.",
        import_no_sessions: "Noch keine Import-Sitzungen. Laden Sie eine Datei hoch, um zu beginnen.",
        import_col_file: "Datei",
        import_col_type: "Typ",
        import_col_items: "Einträge",
        import_col_status: "Status",
        import_col_date: "Datum",
        import_uploaded: "Hochgeladen",
        import_upload_failed: "Upload fehlgeschlagen",
        import_outlook_failed: "Outlook-Import fehlgeschlagen",
        import_admin_consent_failed: "Admin-Einwilligungslink konnte nicht erstellt werden",
        import_deleted: "Gelöscht",
        import_parsing_background: "Verarbeitung im Hintergrund — bei großen Archiven kann das einige Minuten dauern.",
        import_candidates_parsed: "{{n}} Kandidaten verarbeitet",
        import_status_parsing: "Wird verarbeitet",
        import_status_review: "Zur Prüfung",
        import_status_committing: "Wird importiert",
        import_status_done: "Fertig",
        import_status_failed: "Fehlgeschlagen",
        import_item_status_parsed: "bereit",
        import_item_status_skipped: "übersprungen",
        import_item_status_duplicate: "Duplikat",
        import_item_status_committed: "importiert",
        import_item_status_failed: "fehlgeschlagen",
        import_aria_include: "In Import einbeziehen",
        import_aria_edit: "Details bearbeiten",
        import_aria_toggle_all: "Alle auf dieser Seite umschalten",
        import_field_title: "Titel",
        import_field_company: "Unternehmen",
        import_field_email: "E-Mail",
        import_field_phone: "Telefon",
        import_field_location: "Standort",
        import_back: "Zurück",
        import_error: "Fehler",
        import_error_title: "Importfehler",
        import_session_not_found: "Sitzung nicht gefunden",
        import_contacts_fetched_title: "Kontakte abgerufen",
        import_contacts_ready: "{{n}} Kontakte zur Prüfung bereit",
        import_complete_title: "Import abgeschlossen",
        import_candidates_imported: "{{n}} Kandidaten importiert",
        import_failed_title: "Import fehlgeschlagen",
        import_no_duplicates_title: "Keine Duplikate",
        import_no_duplicates_msg: "Alle Einträge sind eindeutig",
        import_dup_detection_failed: "Duplikaterkennung fehlgeschlagen",
        import_start_failed: "Import konnte nicht gestartet werden",
        import_update_item_failed: "Eintrag konnte nicht aktualisiert werden",
        import_update_items_failed: "Einträge konnten nicht aktualisiert werden",
        import_stat_total: "gesamt",
        import_stat_imported: "importiert",
        import_stat_skipped: "übersprungen",
        import_stat_duplicates: "Duplikate",
        import_stat_ready: "bereit",
        import_graph_attachments: "Anhänge: {{fetched}} von {{contacts}} Kontakten abgerufen",
        import_graph_attachment_errors: ", {{errors}} Abruffehler",
        import_parsing_zip: "Kandidaten werden extrahiert und Dokumente hochgeladen … Bei großen Archiven kann das einige Minuten dauern.",
        import_parsing_graph: "Kontakte werden aus Microsoft 365 abgerufen … Bei großen Kontaktlisten kann das einige Minuten dauern.",
        import_committing: "Import läuft … Kandidaten werden erstellt und Anreicherungs-Jobs eingereiht.",
        import_completed_msg: "Import abgeschlossen. {{n}} Kandidaten wurden erstellt.",
        import_duplicates_found: "{{n}} mögliche Duplikate gefunden",
        import_matches_existing: "stimmt mit vorhandenem überein: {{name}}",
        import_matches_item: "stimmt mit Eintrag überein: {{name}}",
        import_check_duplicates: "Duplikate prüfen",
        import_button_import_n: "{{n}} Kandidaten importieren",
        import_select_all: "Alle auf dieser Seite auswählen",
        colleagues_at: "Kollegen bei {{company}}",
        colleagues_former: "Ehemalige",
        company_contacts: "Kontakte ({{count}})",
        no_company_contacts: "Diesem Unternehmen sind noch keine Kontakte zugeordnet.",
        currently_here: "Aktuell hier",
        previously_here: "Früher hier",
        company_not_found: "Unternehmen nicht gefunden.",

        // Career
        career_history: "Berufserfahrung",
        no_career: "Keine Berufserfahrung erfasst.",
        role: "Position",
        company: "Unternehmen",
        from: "Von",
        to: "Bis",
        description: "Beschreibung",
        present: "heute",
        // Prefix on a headline whose role is a past (ended) position — see candidateRole.js
        role_former_prefix: "ehem.",

        // Education
        education: "Ausbildung",
        no_education: "Keine Ausbildung erfasst.",
        year: "Jahr",

        // Documents
        source_documents: "Source-Dokumente",
        upload_document: "Dokument hochladen",
        re_enrich: "Neu anreichern",
        no_documents: "Noch keine Source-Dokumente. Laden Sie einen Lebenslauf hoch oder starten Sie die Anreicherung.",
        processed: "Verarbeitet",
        pending: "Ausstehend",
        preview: "Vorschau",
        hide: "Ausblenden",
        download: "Herunterladen",

        // Tags
        no_tags: "Keine Tags zugewiesen.",
        tags_computed_help: "Tags werden automatisch aus den Daten des Kontakts abgeleitet und können nicht direkt bearbeitet werden.",
        sourced_by: "Sourced von",
        sourced_by_help: "Personen, die diesen Kontakt eingebracht oder vermittelt haben. Hinzugefügte Personen erhalten die Rolle \"Quelle\".",
        add_tag: "Tag hinzufügen...",
        suggested_tags: "Tag-Vorschläge",
        select_all: "Alle auswählen",
        select_row: "Zeile auswählen",
        selected_count: "{{count}} ausgewählt",
        select_hint: "Kandidaten anhaken, um sie einem Projekt hinzuzufügen",
        select: "Auswählen",
        bulk_add_prompt: "{{count}} ausgewählte Kontakt(e) zu einem Projekt hinzufügen.",
        bulk_added_to_project: "{{added}} Kontakt(e) zu {{project}} hinzugefügt ({{skipped}} bereits vorhanden).",
        bulk_add_tag: "Tag hinzufügen",
        bulk_remove_tag: "Tag entfernen",
        bulk_delete: "Löschen",
        delete_selected_title: "Kontakte löschen",
        delete_selected_confirm_one: "Möchten Sie {{count}} Kontakt wirklich löschen? Dies kann innerhalb von 30 Tagen rückgängig gemacht werden.",
        delete_selected_confirm_other: "Möchten Sie {{count}} Kontakte wirklich löschen? Dies kann innerhalb von 30 Tagen rückgängig gemacht werden.",
        contacts_deleted_msg_one: "{{count}} Kontakt gelöscht",
        contacts_deleted_msg_other: "{{count}} Kontakte gelöscht",
        tag_to_remove: "Zu entfernendes Tag",
        clear_selection: "Auswahl aufheben",
        tags_updated: "Tags aktualisiert",
        tags_updated_msg: "{{count}} Kontakte aktualisiert",
        apply: "Anwenden",
        no_results: "Keine Ergebnisse",

        // Timeline activities
        activity_meeting: "Meeting",
        activity_call: "Telefonat",
        activity_email: "E-Mail",
        activity_note: "Notiz",
        activity_compensation: "Vergütung",
        activity_reference: "Referenz",
        activity_status_change: "Statusänderung",
        activity_status_change_moved: "{{actor}} hat den Kandidaten von {{fromStage}} nach {{toStage}} verschoben",
        activity_status_change_added: "{{actor}} hat den Kandidaten in {{toStage}} hinzugefügt",
        activity_unknown_user: "Unbekannter Nutzer",
        activity_field_change: "Änderung",
        activity_field_added: "{{actor}} hat {{field}} gesetzt: {{value}}",
        activity_field_removed: "{{actor}} hat {{field}} entfernt (vorher: {{value}})",
        activity_field_changed: "{{actor}} hat {{field}} geändert: {{from}} → {{to}}",
        activity_field_changed_prefix: "{{actor}} hat {{field}} geändert",
        activity_field_added_prefix: "{{actor}} hat {{field}} gesetzt",
        activity_field_removed_prefix: "{{actor}} hat {{field}} gelöscht",
        activity_field_grouped: "{{actor}} hat {{field}} aktualisiert ({{count}} Änderungen)",
        activity_candidate_created: "Kontakt hinzugefügt",
        activity_candidate_created_body: "{{actor}} hat diesen Kontakt hinzugefügt",
        today: "Heute",
        yesterday: "Gestern",
        load_more: "Mehr laden",
        history_view: "Versionsverlauf",
        history_title: "Änderungsverlauf",
        history_loading: "Wird geladen…",
        history_empty: "Noch keine früheren Versionen.",
        history_removed: "(entfernt)",
        history_blank: "(leer)",
        history_restore: "Wiederherstellen",
        history_restored: "Version wiederhergestellt.",
        activity_system: "System",
        add_note_placeholder: "Notiz hinzufügen... (was ist passiert?)",
        delete_activity: "Eintrag löschen",
        delete_activity_confirm: "Möchten Sie diesen Eintrag wirklich löschen?",

        // Web findings
        web_findings: "Web-Fundstellen",
        web_findings_empty: "Noch keine Web-Fundstellen.",
        web_findings_empty_help: "Die Websuche läuft im Rahmen der Anreicherung — beim Import, beim Hinzufügen eines Dokuments oder über „Neu anreichern“ — und sucht nach Presse, Mandaten, Auszeichnungen und Publikationen.",
        web_findings_needs_context: "Zuerst Titel oder Firma ergänzen — die Websuche benötigt mindestens eine Angabe zur eindeutigen Identifikation.",
        enrich_incl_web: "Anreichern inkl. Websuche",
        documents_reenrich_hint: "Das Hochladen eines Dokuments oder Hinzufügen eines Transkripts startet die Anreicherung automatisch neu (inkl. Websuche).",
        enrich_linkedin: "LinkedIn",
        enrich_web: "Web",
        enrich_li_updated: "aktualisiert {{date}}",
        enrich_li_notyet: "noch nicht abgerufen",
        enrich_li_invalid: "Link ungültig",
        enrich_li_mismatch: "Name passt nicht — Bestätigung offen",
        enrich_li_nourl: "keine URL",
        enrich_web_searched: "durchsucht {{date}}",
        enrich_web_notyet: "noch nicht durchsucht",
        enrich_web_nocontext: "benötigt Titel oder Firma",
        finding_board: "Gremien/Aufsichtsräte",
        finding_press: "Presse",
        finding_publications: "Publikationen",
        finding_awards: "Auszeichnungen",
        finding_conferences: "Konferenzen",
        finding_other: "Sonstige",

        // Clients
        clients: "Klienten",
        add_client: "Klient hinzufügen",
        no_clients: "Noch keine Klienten. Fügen Sie Ihren ersten Klienten hinzu.",
        company_name: "Firmenname",
        company_name_placeholder: "z.B. MediaGroup AG",
        industry_placeholder: "z.B. Medien, Technologie",
        notes_placeholder: "Interne Notizen zu diesem Klienten...",
        contacts: "Kontakte",
        add_contact: "Kontakt hinzufügen",
        no_contacts: "Keine Kontakte",
        role_position: "Funktion / Position",
        mobile: "Mobil",
        direct_dial: "Durchwahl",
        phone_main: "Telefon (Zentrale)",
        assistant_name: "Assistenz Name",
        assistant_phone: "Assistenz Telefon",
        assistant_mobile: "Assistenz Mobil",
        contact_mobile: "Mobil: {{phone}}",
        contact_direct: "Durchwahl: {{phone}}",
        contact_phone: "Tel: {{phone}}",
        contact_assistant: "Asst: {{name}}",
        link_to_candidate: "Person zum Hinzufügen als Kontakt suchen...",
        linked_to: "Verknüpft: {{name}}",
        link_contact_help: "Suchen und verknüpfen Sie eine vorhandene Person. Um jemanden Neues hinzuzufügen, legen Sie zuerst einen Kontakt an.",
        already_linked: "Bereits verknüpft",
        already_linked_msg: "{{name}} ist bereits Kontakt dieses Kunden.",
        unlink: "Verknüpfung lösen",
        create_as_candidate: "Als Person anlegen",
        view_profile: "Profil anzeigen",

        // Rollen
        roles: "Rollen",
        role_candidate: "Kandidat",
        role_client: "Klient",
        role_reference: "Referenz",
        role_source: "Source",
        role_ident: "Identifiziert",
        role_interestingPotential: "Potenzial",

        // Projektkandidat
        source_label: "Source",
        source_direct_approach: "Direktansprache",
        source_referral: "Empfehlung",
        source_application: "Bewerbung",
        source_database: "Datenbank",
        source_linkedin_recruiter: "LinkedIn Recruiter",

        // RHP-Entwurf (KI)
        generate_ai_draft: "KI-Entwurf erstellen",
        draft_longlist_copy: "Executive Summary + Anmerkungen schreiben",
        draft_assessment_copy: "Bewertungstexte + Persönlichkeit schreiben",
        executive_summary: "Executive Summary",
        personality_notes: "Persönlichkeit",
        assessment_sections: "Bewertungsabschnitte",
        annotations: "Anmerkungen",
        annotation_placeholder: "Anmerkung hinzufügen...",
        annotations_help: "Anmerkungen erscheinen in den generierten Dokumenten. Auf einen Eintrag klicken zum Bearbeiten.",
        verdict: "Votum",
        verdict_unset: "—",
        verdict_go: "Geeignet",
        verdict_nogo: "Nicht geeignet",
        processing_remarks: "Hinweise zur Generierung",
        processing_remarks_help: "Hinweise der KI zu den verarbeiteten Daten — Datenqualitätsprobleme, widersprüchliche Quellen, Unklarheiten. Nur für die Beratung; nicht Teil der mandantenseitigen Dokumente. Nach Kenntnisnahme entfernen.",
        draft_status_generating: "wird erstellt…",
        draft_status_complete: "erstellt",
        draft_status_failed: "Fehler bei Entwurf",
        draft_last_generated: "zuletzt erstellt {{date}}",
        draft_overwrite_title: "Bestehende Inhalte überschreiben?",
        draft_overwrite_intro: "Diese Felder enthalten bereits Inhalte und würden ersetzt:",
        draft_overwrite_warning: "Dies kann nicht rückgängig gemacht werden. Leere Felder werden in jedem Fall gefüllt.",
        draft_overwrite_confirm: "Überschreiben",
        draft_continue: "Fortfahren",
        draft_blocked_approved: "Freigegebene Inhalte bleiben unverändert:",
        draft_done: "KI-Entwurf fertig",
        draft_done_msg: "Die Textfelder wurden aktualisiert.",
        draft_failed: "KI-Entwurf fehlgeschlagen",
        draft_failed_msg: "Beim Erstellen des Entwurfs ist ein Fehler aufgetreten.",

        // Herkunft / Provenance
        provenance_ai_generated: "KI",
        provenance_human_edited: "Bearbeitet",
        provenance_human_written: "Berater",
        provenance_human_approved: "Freigegeben",
        approve: "Freigeben",
        approved: "Freigegeben",

        // Anforderung × Realität
        competency_assessment: "Kompetenzen — Anforderung vs. Realität",
        competency_assessment_help: "Jede Karte stellt die Anforderung der Rolle (links) der Realität des Kandidaten (rechts) gegenüber. Der Score ist die Bewertung des Beraters (1 = schwach, 5 = stark); der Fließtext kann per KI vorbefüllt und je Dimension freigegeben werden.",
        requirement: "Anforderung",
        reality: "Realität",
        score: "Score",
        score_scale_hint: "1 = schwach · 5 = stark",
        no_requirement_set: "Noch keine Anforderung hinterlegt — klicken zum Hinzufügen.",
        edit_requirement: "Anforderung bearbeiten",
        requirement_placeholder: "Was verlangt die Rolle in dieser Dimension?",
        assessment_narrative_placeholder: "Wie erfüllt der Kandidat diese Dimension?",
        scores_required_title: "Bitte zuerst bewerten",
        scores_required_msg: "Bitte den Kandidaten in mindestens einer Kompetenzdimension bewerten, bevor Bewertungstexte und Persönlichkeitsnotizen erstellt werden.",
        discard: "Verwerfen",

        // Referenzen
        references: "Referenzen",
        references_help: "Weitere Kontakte, die diese Person für dieses Projekt empfohlen oder referenziert haben. Ein Referenzgeber wird mit der Rolle \"Referenz\" markiert.",
        references_search_placeholder: "Kontakte suchen...",

        // Unternehmen
        companies: "Unternehmen",
        companies_count: "{{count}} Unternehmen",
        add_company: "Unternehmen hinzufugen",
        search_companies: "Unternehmen suchen...",
        no_companies: "Keine Unternehmen gefunden.",
        company_exists: "Unternehmen existiert bereits",
        aliases: "Aliase",
        aliases_placeholder: "Alternative Namen, kommagetrennt",
        website: "Website",
        company_dedup_title: "Doppelte Unternehmen",
        company_dedup_body: "{{groups}} Gruppen sehen aus wie dieselbe Firma ({{sources}} zusätzliche Datensätze). Der genannte Eintrag bleibt. Die anderen werden in ihn übernommen und danach gelöscht. Karriere-Verknüpfungen werden umgeschrieben. Das lässt sich nicht rückgängig machen.",
        company_dedup_merge_all: "Alle Gruppen zusammenführen",
        company_dedup_merge_group: "Diese Gruppe zusammenführen",
        company_dedup_keep: "Behalten",
        company_dedup_absorb: "Wird übernommen",
        company_dedup_people: "{{count}} Personen",
        company_dedup_has_logo: "Logo",
        company_dedup_confirm_title: "Doppelte Unternehmen zusammenführen?",
        company_dedup_confirm_all: "In jeder Gruppe bleibt der genannte Eintrag. Die anderen {{count}} Datensätze werden gelöscht. Karriereinträge zeigen danach auf das behaltene Unternehmen.",
        company_dedup_confirm_group: "\"{{name}}\" bleibt. Die anderen {{count}} Namen werden übernommen und gelöscht.",
        company_dedup_running: "Unternehmen werden zusammengeführt…",
        company_dedup_done: "{{count}} Unternehmen zusammengeführt",
        company_dedup_empty: "Keine zusammenführbaren Duplikate.",
        company_dedup_skipped: "Übersprungen — ähnliche Namen mit unterschiedlichen LinkedIn-Unternehmens-IDs",
        company_dedup_load_failed: "Doppelte Gruppen konnten nicht geladen werden",
        company_dedup_started: "Zusammenführung in der Warteschlange",
        company_dedup_finished: "Zusammenführung abgeschlossen",

        // Projects
        projects: "Projekte",
        new_project: "Neues Projekt",
        no_projects: "Noch keine Projekte. Erstellen Sie Ihr erstes Projekt.",
        project_title: "Projekttitel",
        project_title_placeholder: "z.B. Projekt Phoenix",
        edit_project: "Projekt bearbeiten",
        project_status: "Status",
        project_status_potential: "Potenziell",
        project_status_active: "Aktiv",
        project_status_onHold: "Pausiert",
        project_status_neverStarted: "Nicht gestartet",
        project_status_completed: "Abgeschlossen",
        project_status_closed: "Abgebrochen",
        project_status_group_live: "Offen",
        project_status_group_terminal: "Beendet",
        client: "Klient",
        select_client: "Klient auswählen",
        role_title: "Rollentitel",
        role_briefing: "Rollenbeschreibung",
        role_briefing_placeholder: "Beschreiben Sie die Anforderungen der Rolle...",
        updated_date: "Aktualisiert {{date}}",
        not_linked: "Keinen Projekten zugeordnet.",

        // Project pipeline
        pipeline: "Pipeline",
        documents: "Dokumente",
        settings: "Einstellungen",
        generate_document_btn: "Dokument erstellen",
        project_not_found: "Projekt nicht gefunden.",
        project_files: "Projektdateien",
        upload_file: "Datei hochladen",
        dropzone_title: "Dateien hier ablegen oder klicken zum Hochladen",
        dropzone_hint: "Beliebiger Dateityp",
        no_files_uploaded: "Noch keine Dateien hochgeladen.",
        file_removed: "Datei entfernt",
        document_removed: "Dokument entfernt",
        delete_file_failed: "Datei konnte nicht gelöscht werden",
        delete_document_failed: "Dokument konnte nicht gelöscht werden",
        n_candidates: "{{count}} Kandidaten",
        tab_status: "Suchstand",
        status_print: "Drucken",
        status_people_one: "{{count}} Person",
        status_people_other: "{{count}} Personen",
        status_companies_one: "{{count}} Unternehmen",
        status_companies_other: "{{count}} Unternehmen",
        status_subtitle: "Betrachtete Unternehmen, dann wer abgelehnt hat und warum. Unternehmen aufklappen, um zu sehen, um wen es sich handelt. Beim Drucken bleiben die Namen verborgen — geeignet für den Mandanten.",
        status_empty: "Nehmen Sie Personen in die Suche auf. Deren aktuelle Arbeitgeber erscheinen hier.",
        status_companies_heading: "Betrachtete Unternehmen",
        status_no_companies: "Für die Personen auf dieser Suche ist kein aktueller Arbeitgeber hinterlegt.",
        status_unknown_employer_one: "{{count}} Person ohne aktuellen Arbeitgeber",
        status_unknown_employer_other: "{{count}} Personen ohne aktuellen Arbeitgeber",
        status_reasons_heading: "Absagen",
        status_still_on_search: "Noch in der Suche",
        status_themes_heading: "Themen für das Gespräch",
        status_no_rejected: "Noch niemand ausgeschieden. Ablehnungsnotizen in der Pipeline werden hier zu Gruppen.",
        status_stale_title: "Gründe haben sich geändert",
        status_stale_body: "Seit der letzten Gruppierung wurden Personen oder Notizen geändert. Vor dem Mandantengespräch neu gruppieren.",
        status_grouping: "Gründe werden gruppiert…",
        status_grouped: "Gründe gruppiert",
        status_group_failed: "Gründe konnten nicht gruppiert werden",
        status_group_for_client: "Gründe für den Mandanten gruppieren",
        status_prepare_reasons: "Gründe aufbereiten",
        status_group_credits: "{{credits}} Credits",
        status_label_save_failed: "Bezeichnung konnte nicht gespeichert werden",
        status_load_failed: "Suchstand konnte nicht geladen werden",

        // Pipeline stages
        stage_identified: "Identifiziert",
        stage_longlist: "Longlist",
        stage_shortlist: "Shortlist",
        stage_interview: "Interview",
        stage_finalist: "Finalist",
        stage_placed: "Platziert",
        stage_rejected: "Abgelehnt",
        filter_by_project: "Nach Projekt filtern…",
        no_candidates_in_stage: "Keine Kandidaten",
        stage_update_failed: "Phase konnte nicht aktualisiert werden",
        ranking_update_failed: "Bewertung konnte nicht aktualisiert werden",

        // Rejected
        rejected: "Abgelehnt",
        was_stage: "war: {{stage}}",
        restore: "Wiederherstellen",
        details: "Details",
        search_rejected: "Abgelehnte suchen...",
        rejected_filter_unattributed: "Ohne Angabe",
        no_rejected_match: "Keine abgelehnten Kontakte passen zur Suche.",
        add_reason: "Grund hinzufügen…",
        reason_save_failed: "Ablehnungsgrund konnte nicht gespeichert werden",
        reject_candidate: "Kandidat ablehnen",
        reject_reason: "Grund",
        reject_who_initiated: "Wer hat abgelehnt?",
        reject_initiator_placeholder: "Nicht angegeben",
        rejection_candidate: "Kandidat hat abgesagt",
        rejection_consultant: "Wir haben abgelehnt",
        rejection_client: "Klient hat abgelehnt",
        rejection_none: "Abgelehnt, ohne Angabe",
        rejection_clerical: "Klerikaler Fehler (versehentlich hinzugefügt)",
        rejection_clerical_help: "Entfernt den Kontakt vollständig aus diesem Projekt. Es wird kein Ablehnungsdatensatz angelegt; wenn keine weiteren Projekte mit ihm verknüpft sind, wird er nicht mehr als Kandidat geführt.",
        remove_from_project: "Aus Projekt entfernen",
        removed: "Entfernt",
        clerical_removed_msg: "Kontakt aus diesem Projekt entfernt.",
        reject_notes: "Notizen (optional)",
        reject_notes_placeholder: "Zusätzlicher Kontext...",
        reject: "Ablehnen",
        reject_failed: "Ablehnung fehlgeschlagen",
        restore_failed: "Wiederherstellung fehlgeschlagen",

        // Kandidaten-Drawer — Kopf, Absage, KI-Entwurf, Textabschnitte
        stage_label: "Phase",
        ranking_label: "Ranking",
        no_ranking: "Kein Ranking",
        update_failed: "Aktualisierung fehlgeschlagen",
        restore_to_pipeline: "Zur Pipeline zurückholen",
        last_stage: "Letzte Phase: {{stage}}",
        rejection_reason_label: "Ablehnungsgrund",
        rejection_reason_placeholder: "Warum wurde dieser Kandidat abgelehnt?",
        rejection_reason_saved: "Ablehnungsgrund aktualisiert",
        no_competency_dimensions: "Für dieses Projekt sind keine Kompetenzdimensionen konfiguriert. Im Tab „Einstellungen“ hinzufügen.",
        executive_summary_placeholder: "KI-generierte oder manuell verfasste Executive Summary dieses Kandidaten für den Kunden …",
        personality_notes_placeholder: "Beobachtungen zu Persönlichkeit, kultureller Passung, Kommunikationsstil …",
        field_updated: "{{field}} aktualisiert",
        field_save_failed: "{{field}} konnte nicht gespeichert werden",
        approve_failed: "Freigabe fehlgeschlagen",
        dismiss_failed: "Hinweis konnte nicht verworfen werden",
        draft_longlist_hint: "Aus Lebenslauf und Profil. Keine Bewertung nötig.",
        draft_assessment_hint: "Mindestens eine Note nötig. Aktualisiert auch Executive Summary und Anmerkungen oben, sofern sie nicht freigegeben sind.",
        remarks_missing_title: "Anmerkungen fehlen noch",
        remarks_missing_body: "{{count}} der ausgewählten Kandidaten haben noch keine Anmerkungen. Diese Stellen in der Longlist bleiben leer.",
        remarks_missing_create: "Jetzt erstellen",
        remarks_missing_anyway: "Trotzdem erzeugen",
        remarks_creating: "Anmerkungen werden geschrieben…",
        remarks_create_failed: "Anmerkungen konnten nicht für alle Kandidaten erstellt werden. Das Dokument wird mit dem vorhandenen Stand erzeugt.",

        // Add candidate to project
        add_candidate_to_project: "Kandidat zum Projekt hinzufügen",
        candidate_added: "Kandidat hinzugefügt",
        candidate_added_msg: "Kandidat zum Projekt hinzugefügt",
        add_candidate_failed: "Kandidat konnte nicht hinzugefügt werden",
        already_added: "Bereits hinzugefügt",
        add_existing_candidate: "Bestehenden Kontakt hinzufügen",
        bulk_add_from_linkedin: "Aus LinkedIn-URLs hinzufügen",
        bulk_add_modal_title: "Kontakte aus LinkedIn-URLs hinzufügen",
        bulk_add_modal_hint: "LinkedIn-Profil-URLs einfügen, eine pro Zeile. Jede URL wird zu einem Kontakt, der diesem Projekt in der Phase „Identifiziert“ hinzugefügt wird; die LinkedIn-Anreicherung läuft automatisch für neue Kontakte.",
        linkedin_urls_placeholder: "https://www.linkedin.com/in/jane-doe-123/\nhttps://www.linkedin.com/in/john-smith/",
        bulk_done_title: "LinkedIn-Import abgeschlossen",
        bulk_result_summary: "{{created}} erstellt, {{addedExisting}} zum Projekt hinzugefügt, {{alreadyOnProject}} bereits im Projekt, {{invalid}} ungültig",
        bulk_failed: "LinkedIn-Import fehlgeschlagen",
        add_candidate_dialog_title: "Kontakt hinzufügen",
        add_candidate_new: "Neuen Kontakt anlegen",
        add_candidate_files_hint: "Lebenslauf, Foto oder vCard (.vcf) für einen neuen Kontakt ablegen – Name, Kontaktdaten und Profil werden aus den Dateien gelesen.",
        add_candidate_urls_label: "LinkedIn-URLs – eine pro Zeile, je ein Kontakt",
        add_candidate_tab_file: "Datei / CV",
        add_candidate_tab_manual: "Manuell",
        add_candidate_added_to_project: "Wird zu „{{project}}“ hinzugefügt",
        add_candidate_no_files: "Bitte zuerst eine Datei ablegen oder auswählen.",
        add_candidate_no_urls: "Bitte mindestens eine LinkedIn-URL einfügen.",
        add_candidate_create_many: "{{count}} Kontakte erstellen",
        add_candidate_created: "Kontakt angelegt",
        assign_to_project_optional: "Zu Projekt hinzufügen (optional)",

        // Project settings
        eval_dimensions: "Bewertungsdimensionen",
        eval_dimensions_desc: "Definieren Sie die Kompetenzdimensionen zur Bewertung der Kandidaten in diesem Projekt. Diese werden als Spaltenüberschriften in Longlist-/Shortlist-Dokumenten verwendet.",
        no_dimensions: "Keine Dimensionen definiert. Das System verwendet Standardwerte bei der Anreicherung.",
        add_dimension_placeholder: "Dimension hinzufügen (z.B. Führung, Treasury, PE/VC)",
        no_dimensions_alert_title: "Noch keine Bewertungsdimensionen",
        no_dimensions_alert_body: "Ohne Dimensionen können Kandidaten nicht bewertet werden, KI-Entwürfe haben nichts zu interpretieren, und Longlist-/Shortlist-Dokumente erhalten keine aussagekräftigen Spalten. Definieren Sie diese jetzt — Führung, M&A, Treasury usw.",
        no_dimensions_alert_cta: "Dimensionen hinzufügen",
        search_observations: "Suchbeobachtungen",
        search_observations_desc: "Markteinblicke und allgemeine Erkenntnisse zur Suche. Werden in erstellte Dokumente aufgenommen.",
        search_observations_placeholder: "z.B. CFO-Profile mit sowohl PE-Exit- als auch Retail-B2C-Erfahrung sind in der DACH-Region selten...",
        industry_experts: "Branchenexperten",
        industry_experts_desc: "Kontakte, die das Team befragt, um die Branche für diese Suche kennenzulernen. Erhalten die Rolle \"Source\".",
        no_industry_experts: "Keine Branchenexperten hinzugefügt.",
        sources_help: "Kontakte, die für Brancheneinblicke befragt werden. Manche werfen selbst den Hut in den Ring.",
        no_sources: "Noch keine Sources. Kontakte hinzufügen, die als Informanten für diese Suche dienen.",
        promote_source_to_candidate: "Zu Kandidaten verschieben",
        source_promoted: "Als Kandidat übernommen",
        source_promoted_msg: "Source in die Pipeline als Kandidat aufgenommen.",
        no_candidate_matches: "Keine passenden Kontakte",
        saved: "Gespeichert",
        project_updated: "Projekt aktualisiert",
        save_failed: "Speichern fehlgeschlagen",

        // Search
        candidate_search: "Kontaktsuche",
        search_placeholder: "Kontakte suchen...",
        filters: "Filter",
        any_location: "Alle Standorte",
        any_skills: "Alle Fähigkeiten",
        any_language: "Alle Sprachen",
        any_tags: "Alle Tags",
        clear_all: "Alle zurücksetzen",
        try_search: "Versuchen Sie:",
        similar_banner: "Kandidaten ähnlich zum ausgewählten Profil",
        clear: "Zurücksetzen",
        results_count: "{{count}} Kandidat(en) gefunden",

        // Import
        import_candidates: "Kontakte importieren",
        upload_vcf_zip: "VCF oder ZIP hochladen",
        import_outlook: "Aus Outlook importieren",
        admin_consent_link: "Admin-Zustimmungs-Link",
        admin_consent_tooltip: "Falls Ihr Microsoft-365-Administrator die App freigeben muss, erhalten Sie hier einen Link zum Weiterleiten",
        import_description: "Laden Sie eine .vcf/.zip-Datei hoch oder importieren Sie Kontakte direkt aus Ihrem Microsoft 365 Outlook-Konto.",
        no_imports: "Noch keine Importsitzungen. Laden Sie eine Datei hoch.",
        file: "Datei",
        type: "Typ",
        items: "Einträge",
        include: "Einschließen",
        files: "Dateien",
        total: "gesamt",
        imported: "importiert",
        skipped: "übersprungen",
        duplicates: "Duplikate",
        ready: "bereit",
        check_duplicates: "Duplikate prüfen",
        import_count: "{{count}} Kontakte importieren",
        fetching_contacts: "Kontakte werden aus Microsoft 365 abgerufen... Dies kann bei großen Kontaktlisten einige Minuten dauern.",
        import_in_progress: "Import läuft... Kontakte werden erstellt und Anreicherungsjobs eingereiht.",
        import_completed: "Import abgeschlossen. {{count}} Kontakte wurden erstellt.",
        duplicates_found: "{{count}} mögliche Duplikate gefunden",
        matches_existing: "entspricht vorhandenem: {{name}}",
        matches_item: "entspricht Eintrag: {{name}}",

        // Admin tags
        tag_definitions: "Tag-Definitionen",
        add_tag_title: "Tag hinzufügen",
        tag_name_placeholder: "Tag-Name",
        defined_tags: "Definierte Tags ({{count}})",
        no_tags_defined: "Noch keine Tags definiert. Fügen Sie welche oben hinzu.",
        tag: "Tag",
        created: "Erstellt",

        // Navbar
        nav_candidates: "Kontakte",
        nav_projects: "Projekte",
        nav_clients: "Klienten",
        nav_search: "Suche",
        nav_documents: "Dokumente",
        nav_tools: "Werkzeuge",
        nav_tasks: "Aufgaben",
        tasks_page_title: "Aufgaben",
        tasks_add: "Aufgabe hinzufügen",
        tasks_edit: "Aufgabe bearbeiten",
        tasks_delete: "Aufgabe löschen",
        tasks_delete_confirm: "Diese Aufgabe löschen? Das kann nicht rückgängig gemacht werden.",
        tasks_title_label: "Titel",
        tasks_title_placeholder: "Was ist zu tun?",
        tasks_title_required: "Titel ist erforderlich",
        tasks_notes_label: "Notizen",
        tasks_due_date: "Fällig am",
        tasks_assignee: "Zugewiesen an",
        tasks_unassigned: "Nicht zugewiesen",
        tasks_important: "Wichtig",
        tasks_quick_today: "Heute",
        tasks_quick_tomorrow: "Morgen",
        tasks_quick_week: "+1 Woche",
        tasks_quick_month: "+1 Monat",
        tasks_client_from_project: "Aus dem verknüpften Projekt",
        tasks_view_list: "Liste",
        tasks_view_agenda: "Agenda",
        tasks_filter_project: "Nach Projekt filtern",
        tasks_filter_assignee: "Nach Person filtern",
        tasks_load_more: "Mehr laden",
        tasks_bucket_overdue: "Überfällig",
        tasks_bucket_today: "Heute",
        tasks_bucket_tomorrow: "Morgen",
        tasks_bucket_thisweek: "Diese Woche",
        tasks_bucket_later: "Später",
        tasks_bucket_nodate: "Kein Datum",
        notifications_title: "Benachrichtigungen",
        notifications_empty: "Alles erledigt.",
        notifications_mark_all_read: "Alle als gelesen markieren",
        notifications_aria: "Benachrichtigungen",
        tasks_link_project: "Projekt",
        tasks_link_client: "Klient",
        tasks_link_none: "Keine",
        tasks_overdue: "Überfällig",
        tasks_due_today: "Heute fällig",
        tasks_load_failed: "Aufgaben konnten nicht geladen werden",
        tasks_save_failed: "Aufgabe konnte nicht gespeichert werden",
        tasks_delete_failed: "Aufgabe konnte nicht gelöscht werden",
        tasks_empty: "Noch keine Aufgaben. Legen Sie die erste an.",
        tasks_empty_panel: "Hier sind noch keine Aufgaben verknüpft.",
        tasks_no_match: "Nichts in dieser Liste.",
        tasks_list_myDay: "Mein Tag",
        tasks_list_planned: "Geplant",
        tasks_list_important: "Wichtig",
        tasks_list_assigned: "Mir zugewiesen",
        tasks_list_all: "Alle (Team)",
        tasks_list_completed: "Erledigt",
        tab_tasks: "Aufgaben",
        nav_activity: "Aktivität",
        nav_spend_report: "Kosten",
        spend_report_title: "Kostenübersicht",
        spend_report_subtitle: "Verbrauchte Credits der letzten {{n}} Tage, nach Aktion. Eine Prüfansicht – keine Rechnung.",
        spend_last_window: "Letzte {{n}} Tage",
        spend_balance: "Aktuelles Guthaben",
        spend_credits_unit: "Credits",
        spend_by_action: "Nach Aktion (letzte {{n}} Tage)",
        spend_recent: "Letzte Buchungen",
        spend_empty: "Noch keine Credit-Buchungen erfasst.",
        spend_col_action: "Aktion",
        spend_col_count: "Anzahl",
        spend_col_credits: "Credits",
        spend_col_cost: "Kosten",
        spend_col_date: "Datum",
        spend_col_detail: "Detail",
        spend_capped: "Zeigt die letzten {{n}} Buchungen.",
        spend_history_note: "Die Zusammenfassung umfasst die letzten 30 Tage; die Liste darunter zeigt die letzten Buchungen seit Beginn der Credit-Erfassung.",
        spend_action_linkedinFetch: "LinkedIn-Abruf",
        spend_action_webSearch: "Websuche",
        spend_action_cvExtraction: "Lebenslauf-Analyse",
        spend_action_compensationExtraction: "Vergütungs-Analyse",
        spend_action_consentParse: "Einwilligungs-Analyse",
        spend_action_documentClassification: "Dokumentklassifizierung",
        spend_action_transcriptExtraction: "Transkript-Extraktion",
        spend_action_publicDataExtraction: "Öffentliche-Daten-Extraktion",
        spend_action_searchProfile: "Suchprofil",
        spend_action_searchEmbedding: "Suchindexierung",
        spend_action_rhpDraft: "Berichtsentwurf",
        spend_action_transcriptAnalysis: "Transkript-Analyse",
        spend_action_statusReasons: "Suchstand-Gruppierung",
        spend_action_other: "Sonstiges",
        activity_feed_title: "Team-Aktivität",
        activity_feed_subtitle: "Wer was an Ihren Kontakten geändert hat – neueste zuerst.",
        activity_feed_empty: "Noch keine Aktivität.",
        activity_feed_locked_title: "Eine Pro-Funktion",
        activity_feed_locked_body: "Der Team-Aktivitäts-Feed zeigt, wer was an Ihren Kontakten geändert hat – jede Bearbeitung und Anreicherung, von wem. Verfügbar im Pro-Tarif.",
        activity_feed_upgrade_cta: "Auf Pro upgraden",
        nav_users: "Benutzer",
        nav_tags: "Tags",
        nav_api_keys: "API-Schlüssel",
        nav_enrichment: "Anreicherung",
        nav_settings: "Einstellungen",

        // Personal preferences (per-user, in the account menu)
        preferences_nav: "Einstellungen",
        preferences_title: "Einstellungen",
        preferences_subtitle: "Diese Einstellungen gelten nur für Sie.",
        pref_home_title: "Startseite",
        pref_home_help: "Die Seite, die beim Öffnen der App angezeigt wird.",
        home_page_auto: "Automatisch",
        pref_lists_title: "Kontaktlisten",
        pref_lists_help: "Standard-Sortierung für Kontaktlisten. Alphabetisch sortiert immer nach Nachname und zeigt Namen als „Nachname, Vorname“, damit die Reihenfolge nachvollziehbar ist; das Namensformat gilt überall sonst.",
        pref_activity_title: "Aktivitäts-Feed",
        pref_activity_help: "Den Team-Aktivitäts-Feed in Ihrer Navigation anzeigen. Zum Ausblenden deaktivieren – Ihrem Team bleibt die Funktion erhalten.",
        pref_show_activity: "Aktivität in der Navigation anzeigen",

        // Enrichment settings page
        enrichment_settings: "Anreicherungs-Einstellungen",
        default_language: "Standard-Ausgabesprache",
        default_language_help: "Wird für KI-generierte Texte verwendet (Kurzprofile, RHP-Entwürfe). Projekte können diese Einstellung individuell überschreiben.",
        linkedin_refresh: "LinkedIn-Aktualisierung",
        auto_linkedin_refresh: "LinkedIn-Daten im Hintergrund automatisch aktualisieren",
        linkedin_refresh_days: "Aktualisierungsintervall (Tage)",
        max_refresh_per_cycle: "Max. Kandidaten pro Stundenzyklus",
        web_search: "Websuche",
        auto_web_search: "Websuche bei der Anreicherung einbeziehen",
        auto_web_search_on_linkedin_refresh: "Websuche bei jeder LinkedIn-Aktualisierung erneut ausführen",
        auto_web_search_on_linkedin_refresh_help: "Standardmäßig aus — die periodische Aktualisierung bleibt LinkedIn-only (deutlich günstiger). Die Websuche läuft weiterhin beim Import und bei manueller Neu-Anreicherung.",
        cost_estimate_value: "≈ {{credits}} Credits/Monat (≈ {{eur}} €/Monat)",
        cost_estimate_help: "Ungefähre laufende Kosten über {{count}} Kontakte mit LinkedIn-URL beim aktuellen Intervall. Aktualisierungen werden zum halben Preis berechnet; gelegentliches Neu-Einbetten (bei Profiländerung) kommt hinzu.",
        cost_estimate_off: "Auto-Aktualisierung ist aus — keine laufenden Kosten.",
        settings_saved: "Einstellungen gespeichert",
        output_language: "Ausgabesprache",
        output_language_help: "Überschreibt für dieses Projekt die Standardsprache des Mandanten.",
        use_tenant_default: "Mandanten-Standard verwenden",

        // API keys
        api_keys_title: "API-Schlüssel",
        api_keys_intro: "API-Schlüssel erlauben anderen Apps und Skripten den programmatischen Zugriff auf diesen Veft-Mandanten – z. B. um Kontakte in die Monego-Rechnungsstellung zu übernehmen.",
        api_keys_list_title: "Aktive Schlüssel",
        api_keys_create_title: "API-Schlüssel erstellen",
        api_keys_created_title: "API-Schlüssel erstellt",
        api_keys_create_button: "Schlüssel erstellen",
        api_keys_one_time_intro: "Dein neuer API-Schlüssel:",
        api_keys_one_time_warning: "Dieser Schlüssel wird nicht erneut angezeigt. Bitte sicher speichern.",
        api_keys_name: "Name",
        api_keys_name_placeholder: "Monego Rechnungen",
        api_keys_permission: "Berechtigung",
        api_keys_rate_limit: "Rate-Limit (Anfragen/Min.)",
        api_keys_empty: "Noch keine API-Schlüssel.",
        api_keys_unnamed: "Unbenannt",
        api_keys_never: "Nie",
        api_keys_col_name: "Name",
        api_keys_col_key: "Schlüssel",
        api_keys_col_permission: "Berechtigung",
        api_keys_col_last_used: "Zuletzt verwendet",

        // MCP endpoint
        api_keys_mcp_title: "KI-Agent verbinden (MCP)",
        api_keys_mcp_intro:
          "Veft stellt einen rein lesenden MCP-Endpunkt bereit, über den KI-Agenten wie Claude Kandidaten durchsuchen, Projekte einsehen und Pipelines prüfen können. Als eigener Connector mit API-Schlüssel einbinden:",
        api_keys_mcp_auth_hint: "Authentifizierung über den HTTP-Header",
        copied: "Kopiert",
        copy: "Kopieren",
        nav_admin: "Admin",
        nav_tenants: "Mandanten",
        nav_jobs: "Jobs",
        nav_admin_users: "Admin-Benutzer",

        // Documents page
        document_generation: "Dokumentenerstellung",
        choose_template: "Vorlage auswählen",
        more_templates: "Weitere Vorlagen ({{count}})",
        no_templates: "Keine Vorlagen verfügbar. Kontaktieren Sie Ihren Administrator.",
        select_data_sources: "Datenquellen auswählen",
        project: "Projekt",
        select_project: "Projekt auswählen",
        candidates_selected: "Kandidaten ({{selected}} von {{total}} ausgewählt)",
        no_candidates_on_project: "Noch keine Kandidaten in diesem Projekt.",
        enriching_candidates: "Kandidaten werden angereichert...",
        rendering_document: "Dokument wird erstellt...",
        generate_document: "Dokument erstellen ({{count}} Kandidaten)",
        generation_started: "Erstellung gestartet",
        generation_started_message: "Job eingereiht mit {{count}} Kandidaten",
        generation_done: "Fertig",
        generation_done_message: "Dokument erfolgreich erstellt",
        generation_failed: "Fehlgeschlagen",
        generation_failed_message: "Dokumentenerstellung fehlgeschlagen",
        generated_documents: "Erstellte Dokumente",
        generated_at: "Erstellt {{date}}",
        no_generated_documents: "Noch keine Dokumente erstellt.",
        unknown_candidate: "Unbekannter Kontakt",
        no_file_uploaded: "Keine Datei hochgeladen",
        default_template: "Standard",
        saving: "Speichert…",
        autosave_pending: "Ungespeichert — wird gleich gespeichert",
        delete_source_title: "Source-Dokument löschen",
        delete_source_confirm: "Dieses Source-Dokument vom Kontakt entfernen?",
        delete_source_confirm_extracted: "Die Datei wird entfernt. Bereits übernommene Karrieredaten bleiben am Kontakt.",
        contact_dropzone_hint: "PDF, Word oder RTF",
        template_purpose_longlist: "Longlist",
        template_purpose_shortlist: "Shortlist",
        template_purpose_detailedCv: "Kandidaten-CV",
        template_purpose_clientPresentation: "Kandidatenbericht",
        template_purpose_interviewSummary: "Interviewzusammenfassung",
        template_purpose_referenceCheck: "Referenzauskunft",
        template_purpose_rejectedCandidates: "Abgelehnte Kandidaten",
        template_desc_longlist: "Querformat A4. Eine Seite pro Kandidat in tabellarischem Layout mit Bio-Spalte, Werdegang, Berateranmerkungen und Kompetenzbewertungen. Lesezeichen an jeder Kandidatenüberschrift für Seitenverweise.",
        template_desc_shortlist: "Gleiches Layout wie die Longlist, plus eine Übersichtstabelle oben.",
        template_desc_detailedCv: "Hochformat A4. Ein polierter, rollenoptimierter Lebenslauf im Hausstil. Ein Dokument pro Kandidat.",
        template_desc_clientPresentation: "Hochformat A4. Narrativer Bericht mit Executive Summary, Bewertung je Dimension und Persönlichkeitsnotiz.",
        template_desc_interviewSummary: "Strukturierte Interviewnotizen, Beobachtungen je Kompetenz und Empfehlung.",
        template_desc_referenceCheck: "Angaben zum Referenzgeber, strukturierte Fragen, Antworten und Gesamteinschätzung.",
        template_desc_rejectedCandidates: "Tabellarische Liste abgelehnter oder zurückgezogener Kandidaten, für den Abgleich mit dem Mandanten nach der Longlist-Kalibrierung.",
        template_name_longlist_v1: "Longlist-Präsentation",
        template_name_shortlist_v1: "Shortlist-Bericht",
        template_name_detailed_cv_v1: "Detaillierter Kandidaten-CV",
        template_name_client_presentation_v1: "Mandantenpräsentation",
        template_name_interview_summary_v1: "Interviewzusammenfassung",
        template_name_reference_check_v1: "Referenzauskunft",
        template_name_rejected_candidates_v1: "Liste abgelehnter Kandidaten",
        template_name_longlist_typst_v1: "Longlist (Standard)",
        template_name_detailed_cv_typst_v1: "Kandidaten-CV (Standard)",
        template_name_candidate_report_typst_v1: "Kandidatenbericht (Standard)",

        // Search page
        search_button: "Suchen",
        location_label: "Standort",
        skills_label: "Fähigkeiten",
        languages_label: "Sprachen",
        tags_label: "Tags",
        candidates_found: "{{count}} Kandidat(en) gefunden",
        search_semantic_divider: "Ähnliche Profile (semantische Treffer)",
        search_failed: "Suche fehlgeschlagen — bitte erneut versuchen.",
        search_sort_relevance: "Relevanz",
        search_truncated: "Die Textsuche ist nach 1.000 Treffern abgebrochen. Weitere Seiten können unvollständig sein.",

        tools_intro: "Werkzeuge neben dem Kontakt. Eine Person reicht — kein Projekt nötig.",
        tools_bg_pick: "Kontakt suchen, um die Prüfung zu öffnen.",
        tab_background: "Hintergrundprüfung",
        bg_title: "Hintergrundprüfung",
        bg_intro: "Öffentlicher Webbericht: Presse, Mandate, Verfahren, Auszeichnungen, Publikationen und ein Abgleich mit dem Lebenslauf. Informiert Sie; bewertet und entscheidet nicht.",
        bg_when: "Sie entscheiden, wann — auf der Longlist, später, oder gar nicht.",
        bg_start: "Prüfung starten",
        bg_cost: "≈ {{credits}} Credits ({{price}}) nach der Identitätsbestätigung.",
        bg_charged_on_confirm: "Die Identitätskarte ist kostenlos. Credits fallen erst an, wenn Sie bestätigen, dass es die richtige Person ist.",
        bg_resolving: "Identitätskarte wird erstellt…",
        bg_gate_help: "Bestätigen Sie die Person, bevor eine Tiefensuche läuft. Eine falsche Identität ist der übliche Fehler einer privaten Google-Suche.",
        bg_gate_question: "Ist das die Person?",
        bg_confirm: "Ja — Prüfung starten",
        bg_reject: "Nein — falsche Person",
        bg_running: "Öffentliche Quellen werden durchsucht…",
        bg_running_help: "Presse, Register, Verfahren, Auszeichnungen, Publikationen, dann Lebenslauf-Angaben. Erkenntnisse erscheinen laufend.",
        bg_failed: "Prüfung fehlgeschlagen",
        bg_failed_generic: "Der Lauf ist fehlgeschlagen. Sie können es erneut versuchen.",
        bg_insufficient_identity: "Zu wenig, um die Person eindeutig zu erkennen — bitte Rolle, Arbeitgeber, Ort oder LinkedIn-URL ergänzen.",
        bg_insufficient_credits: "Nicht genug Credits für eine Hintergrundprüfung.",
        bg_retry: "Erneut versuchen",
        bg_rejected_title: "Identität abgelehnt",
        bg_rejected_body: "Dieser Lauf ist beendet. Starten Sie eine neue Prüfung, sobald der Kontakt die richtige Person ist.",
        bg_history: "Frühere Prüfungen",
        bg_findings: "Erkenntnisse",
        bg_claims: "Abgleich mit dem Lebenslauf",
        bg_no_findings: "Keine Erkenntnisse, die die Belegregel erfüllen (wörtliches Zitat + URL).",
        bg_no_claims: "Keine Lebenslauf-Angaben geprüft.",
        bg_download_pdf: "PDF herunterladen",
        bg_report_disclaimer: "Nur öffentliche, stellenrelevante Quellen. „Nicht gefunden“ heißt nicht „geprüft und frei“. Dieser Bericht bewertet und rangiert niemanden.",
        bg_finding_count: "{{count}} Erkenntnis(se)",
        bg_load_failed: "Hintergrundprüfung konnte nicht geladen werden.",
        bg_start_failed: "Prüfung konnte nicht gestartet werden.",
        bg_confirm_failed: "Identität konnte nicht bestätigt werden.",
        bg_reject_failed: "Identität konnte nicht abgelehnt werden.",
        bg_status_awaitingIdentityConfirmation: "Wartet auf Bestätigung",
        bg_status_running: "Läuft",
        bg_status_complete: "Abgeschlossen",
        bg_status_failed: "Fehlgeschlagen",
        bg_status_rejected: "Abgelehnt",
        bg_severity_info: "Hinweis",
        bg_severity_noteworthy: "Beachtenswert",
        bg_severity_critical: "Kritisch",
        bg_cat_press: "Presse",
        bg_cat_publication: "Publikation",
        bg_cat_boardMandate: "Mandat / Register",
        bg_cat_litigation: "Verfahren",
        bg_cat_insolvency: "Insolvenz",
        bg_cat_award: "Auszeichnung",
        bg_cat_conferenceTalk: "Vortrag",
        bg_cat_web: "Web",
        bg_verdict_consistent: "Konsistent",
        bg_verdict_inconsistent: "Abweichend",
        bg_verdict_notFound: "Nicht gefunden",
        bg_claim_tenure: "Zeitraum",
        bg_claim_title: "Titel",
        bg_claim_degree: "Abschluss",

        // In-app assistant (ChatDrawer)
        assistant_trigger_tooltip: "KI-Assistent",
        assistant_trigger_tooltip_locked: "KI-Assistent — Upgrade auf Pro",
        assistant_upgrade_prompt: "Der KI-Assistent ist im Pro-Tarif verfügbar. Bitte führen Sie ein Upgrade durch, um ihn zu nutzen.",
        assistant_title: "Assistent",
        assistant_history: "Gesprächsverlauf",
        assistant_new_conversation: "Neue Unterhaltung",
        assistant_untitled: "Ohne Titel",
        assistant_messages_one: "{{count}} Nachricht",
        assistant_messages_other: "{{count}} Nachrichten",
        assistant_empty_prompt: "Fragen Sie mich zu Ihren Kandidaten, Projekten oder zur Pipeline",
        assistant_thinking: "Denke nach …",
        assistant_input_placeholder: "Stellen Sie eine Frage …",
        assistant_you: "Sie",
        assistant_copy: "Kopieren",
        assistant_error: "Entschuldigung, etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
        assistant_referenced: "Verweise",
        assistant_more: "+{{count}} weitere",
        assistant_candidate_count_one: "{{count}} Kandidat",
        assistant_candidate_count_other: "{{count}} Kandidaten",

        // Search — "why was this found" match signals
        search_match_prefix: "Gefunden über",
        search_matched_in: "Treffer in {{field}}",
        match_field_name: "Name",
        match_field_title: "Position",
        match_field_company: "Unternehmen",
        match_field_skill: "Fähigkeit",
        match_field_tag: "Tag",
        match_field_language: "Sprache",
        match_field_location: "Standort",
        match_field_summary: "Profiltext",
        match_field_profile: "Treffer im Profiltext",
        match_field_document: "In einem Dokument gefunden",
        match_field_semantic: "Semantischer Treffer",
        match_field_fuzzy: "Ähnliche Schreibweise / Wortform",
        search_fuzzy_divider: "Ähnliche Treffer (Schreibweise & Wortformen)",
        match_field_similar: "Ähnliches Profil",

        // Candidate detail
        edit_profile: "Profil bearbeiten",
        candidate_not_found: "Kontakt nicht gefunden.",
        at_company: "bei {{company}}",

        // Timeline
        all_filter: "Alle",
        no_timeline_entries: "Keine Verlaufseinträge.",
        no_entries_of_type: "Keine Verlaufseinträge dieses Typs.",
        activity_transcript: "Transkript",
        show_events: "Ereignisse anzeigen",

        // Notifications
        error: "Fehler",

        // AI features
        ai_summary: "KI-Zusammenfassung",
        summary_generated: "Zusammenfassung erstellt",
        summary_generated_msg: "KI-Zusammenfassung wurde aus allen verfügbaren Quellen erstellt.",
        ai_suggest: "KI-Vorschlag",
        ai_suggested_tags_hint: "KI-vorgeschlagene Tags (klicken zum Hinzufügen):",

        // Transcript
        add_transcript: "Transkript hinzufügen",
        paste_transcript: "Vollständiges Transkript hier einfügen...",
        submit_analyze: "Einreichen & Analysieren",
        transcript_submitted: "Transkript eingereicht",
        transcript_submitted_msg: "Transkript übermittelt. Analyse gestartet; die Anreicherung folgt in wenigen Minuten.",
        transcript_analysis: "Transkript-Analyse",
        analysis_in_progress: "Analyse läuft...",
        insights: "Erkenntnisse",
        people_mentioned: "Erwähnte Personen",
        add_to_project: "Zum Projekt hinzufügen",
        added: "Hinzugefügt",
        added_to_project: "Zum Projekt hinzugefügt",
        added_to_project_msg: "Kandidat zum Projekt hinzugefügt",
        linked: "Verknüpft",
        unresolved: "Nicht zugeordnet",
        analyzed: "Analysiert",
        analyzing: "Wird analysiert...",

        // Transcript types
        transcript_interview: "Interview",
        transcript_reference: "Referenzgespräch",
        transcript_press: "Presse / Medien",
        transcript_informal: "Informell",

        // Source types
        source_cv: "Lebenslauf",
        source_file: "Datei",
        source_linkedin: "LinkedIn",
        source_web: "Web",
        source_manual: "Manuell",
        source_vcf: "VCF",
        source_zip: "ZIP-Import",
        source_transcript: "Transkript",
        source_public: "Öffentlich",
        source_crmNotes: "Notizen",
        source_import: "Import",
        field_sources_title: "Datenherkunft",
        field_sources_help: "Jedes Abzeichen zeigt, welche Quelle dieses Feld zuletzt gesetzt hat — manuell erfasst (Manuell), aus einem Lebenslauf, von LinkedIn, aus Notizen oder beim Import. Manuelle Werte werden durch eine erneute Anreicherung nicht überschrieben.",

        // Upload / enrichment notifications
        uploaded: "Hochgeladen",
        upload_success_msg: "Dokument hochgeladen. Die Analyse startet automatisch in wenigen Minuten – weitere Uploads werden gemeinsam analysiert. „Neu anreichern“ startet sofort.",
        upload_failed: "Upload fehlgeschlagen",
        enrichment_queued: "Anreicherung eingereiht",
        enrichment_queued_msg: "Verarbeitung beginnt in Kürze",
        reenrich_candidate: "Kandidat neu anreichern",
        reenrich_explanation: "Anreicherung aus Lebenslauf, LinkedIn und Websuche neu ausführen. Skills und Notizen werden mit vorhandenen Daten zusammengeführt.",
        reenrich_cost: "Führt eine vollständige Anreicherung aus (inkl. Websuche) — etwa {{credits}} Credits ({{price}}). Die tatsächlichen Kosten können niedriger sein, wenn ein Schritt nichts zu tun hat.",
        refetch_linkedin_explanation: "Lädt nur das LinkedIn-Profil neu. Lebenslauf-Parsing und Websuche werden nicht erneut ausgeführt.",
        overwrite_career_education: "Werdegang und Ausbildung vollständig ersetzen",
        overwrite_career_education_hint: "Werdegang und Ausbildung werden immer aus LinkedIn aktualisiert; von Hand bearbeitete oder gelöschte Einträge bleiben erhalten. Aktivieren, um auch diese zu verwerfen und die abgerufenen Daten unverändert zu übernehmen.",
        refetch_linkedin: "LinkedIn neu laden",
        linkedin_refetch_queued: "LinkedIn-Refetch eingereiht",
        linkedin_refetch_queued_msg: "Profil wird in Kürze neu extrahiert",

        // Ungültiger / toter LinkedIn-Link
        linkedin_invalid_title: "LinkedIn-Link ungültig",
        linkedin_invalid_body: "Dieses LinkedIn-Profil wurde nicht gefunden (404). Vermutlich hat die Person ihr Profil gelöscht oder umbenannt — auch angemeldete Besucher würden denselben Fehler erhalten. Ein erneuter Abruf hilft nicht: Bitte korrigieren Sie die URL oder entfernen Sie sie.",
        linkedin_edit_url: "LinkedIn-URL bearbeiten",
        linkedin_edit_url_hint: "Fügen Sie die korrigierte Profil-URL ein. Beim Speichern einer neuen URL wird der LinkedIn-Abruf erneut ausgeführt.",
        linkedin_try_anyway: "Trotzdem versuchen",
        linkedin_mark_invalid: "Link als ungültig markieren",
        linkedin_marked_invalid: "Link als ungültig markiert",
        linkedin_marked_invalid_msg: "Der LinkedIn-Link ist als ungültig markiert und wird nicht mehr automatisch abgerufen.",

        // LinkedIn-Identität passt nicht (Abruf vom Namens-Check angehalten)
        linkedin_mismatch_title: "LinkedIn-Profil passt nicht zu diesem Kontakt",
        linkedin_mismatch_body: "Das Profil hinter der hinterlegten URL heißt „{{profileName}}“ — das passt nicht zu {{candidateName}}, daher wurde nichts übernommen. Falls es trotzdem dieselbe Person ist (Namensänderung, andere Schreibweise), Profil übernehmen. Andernfalls die URL korrigieren oder entfernen.",
        linkedin_mismatch_accept: "Selbe Person — Profil übernehmen",
        linkedin_mismatch_reject: "Falsches Profil — URL entfernen",
        linkedin_mismatch_removed: "LinkedIn-URL entfernt",
        linkedin_mismatch_removed_msg: "Die URL ist entfernt; aus dem Profil wurde nichts übernommen.",
        linkedin_slug_warning: "Diese URL scheint zu „{{slugName}}“ zu gehören, nicht zu {{candidateName}}. Bitte vor dem Speichern prüfen.",

        // Avatar
        photo_edit: "Foto ändern",
        photo_upload: "Foto hochladen",
        photo_remove: "Foto entfernen",
        photo_updated: "Foto aktualisiert",
        photo_updated_msg: "Das neue Foto ist gespeichert.",
        photo_removed: "Foto entfernt",
        photo_removed_msg: "Das Foto wurde entfernt. Ein LinkedIn-Abruf kann das aktuelle Profilbild wieder laden.",

        // Languages editor
        done: "Fertig",
        select_languages: "Sprachen auswählen...",

        // Delete notifications
        deleted_notification: "Gelöscht",
        candidate_deleted_msg: "{{name}} wurde gelöscht",

        // Plans / billing page
        plans_title: "Tarif & Abrechnung",
        plans_subtitle: "Wählen Sie den Tarif, der zu Ihrer Suche passt. Credits treiben Anreicherung, Entwürfe und Suche an.",
        plans_current_badge: "Aktueller Tarif: {{plan}}",
        plans_interval_monthly: "Monatlich",
        plans_interval_annual: "Jährlich (2 Monate gratis)",
        plans_per_month: "/ Monat",
        plans_billed_yearly: "{{currency}}{{amount}} jährlich abgerechnet",
        plans_lets_talk: "Sprechen wir",
        plans_free: "Kostenlos",
        plans_most_popular: "Am beliebtesten",
        plans_cta_included: "Inbegriffen",
        plans_cta_current: "Aktueller Tarif",
        plans_cta_choose: "{{name}} wählen",
        plans_cta_subscribe: "{{name}} abonnieren",
        plans_cta_manage: "Abonnement verwalten",
        plans_cta_contact: "Vertrieb kontaktieren",
        plans_cta_contact_current: "Aktuell — kontaktieren Sie uns",
        plans_checkout_failed: "Checkout fehlgeschlagen",
        plans_portal_failed: "Abrechnungsportal konnte nicht geöffnet werden",
        plans_footer_more_credits: "Mehr Credits im Pro-Tarif nötig?",
        plans_footer_buy_packs: "Credit-Pakete kaufen",
        plans_footer_questions: "Fragen?",
        plans_footer_contact_us: "Kontaktieren Sie uns",
        // Shared feature labels (reused across tiers)
        plans_feat_bulk_import: "Bulk-Ordner/ZIP-Import",
        plans_feat_ai_api: "KI-Assistent & API-Zugang",
        plans_feat_custom_templates: "Eigene DOCX-Vorlagen",
        // Trial tier
        plans_trial_blurb: "Ausprobieren — 750 Credits, 14 Tage.",
        plans_trial_feat_candidates: "50 Kontakte",
        plans_trial_feat_user: "1 Benutzer",
        plans_trial_feat_cv: "Einzel-CV-Import + Anreicherung",
        plans_trial_feat_buy_credits: "Zusätzliche Credits kaufen",
        // Pro tier
        plans_pro_blurb: "Für aktive Suche. 33.000 Credits / Monat.",
        plans_pro_feat_candidates: "6.000 Kontakte",
        plans_pro_feat_users: "3 Benutzer",
        plans_pro_feat_buy_credits: "Jederzeit zusätzliche Credits kaufen",
        // Enterprise tier
        plans_enterprise_blurb: "Individuelle Limits, eigene Vorlagen, SSO & Priority-Support.",
        plans_ent_feat_unlimited: "Unbegrenzte Kontakte",
        plans_ent_feat_seats: "Individuelle Benutzerplätze",
        plans_ent_feat_sso: "SSO & Priority-Support",
        plans_ent_feat_credits: "Individuelles Credit-Kontingent",

        // Consent settings page (/settings/consent)
        consent_settings_title: "DSGVO-Einwilligung",
        consent_settings_disclaimer: "Die folgende Vorlage ist ein Muster. Sie sind für den rechtlichen Inhalt und die Benennung des korrekten Verantwortlichen selbst verantwortlich. Veft stellt den Mechanismus bereit, nicht den rechtlichen Wortlaut.",
        consent_settings_request_template: "Anfrage-Vorlage",
        consent_settings_tpl_name: "Name",
        consent_settings_tpl_language: "Sprache",
        consent_settings_tpl_validity: "Standard-Gültigkeit",
        consent_settings_tpl_subject: "Betreff",
        consent_settings_tpl_body: "Text",
        consent_settings_placeholders_label: "Platzhalter:",
        consent_settings_controller_microsite: "Verantwortlicher & Microsite",
        consent_settings_controller_identity: "Identität des Verantwortlichen",
        consent_settings_controller_identity_desc: "Wird auf der Bestätigungsseite angezeigt. Fällt auf Ihren Organisationsnamen zurück, wenn leer.",
        consent_settings_microsite_footer: "Microsite-Fußzeile",
        consent_settings_accent_color: "Akzentfarbe (Hex)",
        consent_settings_timing_retention: "Fristen & Aufbewahrung",
        consent_settings_link_validity: "Link gültig für (Tage)",
        consent_settings_overdue_after: "Überfällig nach (Tagen)",
        consent_settings_remind_after: "Erinnerung nach (Tagen, 0 = aus)",
        consent_settings_minimize_label: "Einwilligungsnachweis bei Löschung minimieren",
        consent_settings_minimize_desc: "Aus (empfohlen): Der Einwilligungsnachweis bleibt erhalten, wenn ein Kontakt gelöscht wird, da er Ihr Compliance-Nachweis ist. An: Personenbezogene Daten im Nachweis werden bei der Löschung entfernt (die Kette bleibt über Verknüpfung überprüfbar).",
        consent_settings_save: "Speichern",
        consent_settings_verify_chain: "Ketten-Integrität prüfen",
        consent_settings_chain_intact: "Kette intakt",
        consent_settings_chain_broken: "Unterbrochen bei #{{seq}}",
        consent_settings_saved: "Gespeichert",
        consent_settings_save_error: "Einwilligungseinstellungen konnten nicht gespeichert werden",
        consent_activation_title: "Aktivierung",
        consent_activation_desc: "Das Versenden ist gesperrt, bis Sie es aktivieren — eine Absicherung, damit die Beispielvorlage nie an einen echten Kontakt gesendet wird.",
        consent_activation_switch: "Einwilligungsversand aktivieren",
        consent_activation_status_on: "Aktiv",
        consent_activation_status_off: "Gesperrt",
        consent_activation_placeholder_warning: "Ihre Vorlage enthält noch den Beispieltext („BEISPIELTEXT“). Ersetzen Sie ihn durch Ihren eigenen Wortlaut, um zu aktivieren.",
        consent_test_send_button: "Test an mich senden",
        consent_test_send_sent: "Test-E-Mail an {{email}} gesendet — prüfen Sie Ihr Postfach und klicken Sie den Link, um den Ablauf zu testen.",
        consent_test_send_error: "Test-E-Mail konnte nicht gesendet werden",
        consent_validity_months6: "6 Monate",
        consent_validity_months12: "12 Monate",
        consent_validity_months24: "24 Monate",
        consent_validity_indefinite: "Unbegrenzt",

        // Datenexport (DSGVO) (/settings/export)
        export_nav: "Datenexport",
        export_title: "Datenexport (DSGVO)",
        export_intro: "Laden Sie eine vollständige Kopie aller Daten dieses Kontos herunter — jeden Kontakt (als vCard samt Anhängen und strukturierten Daten), Ihre Projekte, Klienten, Bewertungen und den Einwilligungsverlauf — als eine einzige ZIP-Datei.",
        export_retention_note: "Die fertige Datei enthält personenbezogene Daten. Sie wird 7 Tage aufbewahrt und danach automatisch gelöscht.",
        export_create_heading: "Neuen Export erstellen",
        export_start: "Export starten",
        export_running_hint: "Ihr Export wird vorbereitet. Bei großen Konten kann das einige Minuten dauern — Sie können die Seite verlassen, der Vorgang läuft weiter.",
        export_history: "Ihre Exporte",
        export_empty: "Noch keine Exporte.",
        export_col_created: "Erstellt",
        export_col_contacts: "Kontakte",
        export_col_size: "Größe",
        export_col_expires: "Verfügbar bis",
        export_expired: "Abgelaufen",
        export_download: "Herunterladen",
        export_started: "Export gestartet",
        export_started_msg: "Ihr Export wird vorbereitet.",
        export_ready: "Export bereit",
        export_ready_msg: "Ihre Daten stehen zum Download bereit.",
        export_failed: "Export fehlgeschlagen",
        export_failed_msg: "Der Export konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut.",
        export_already_running: "Für dieses Konto läuft bereits ein Export.",

        // --- Onboarding / contextual help (InfoHint + empty states) ---
        add_candidate_enrich_note: "Beim Hinzufügen eines Kontakts läuft die Anreicherung automatisch.",
        enrichment_intake_help: "Beim Hinzufügen eines Kontakts startet im Hintergrund die Anreicherung: Wir lesen einen hochgeladenen Lebenslauf, rufen das LinkedIn-Profil ab (falls eine URL angegeben ist) und führen eine Websuche durch. Das dauert einige Minuten und verbraucht Credits. Die Ergebnisse erscheinen im Profil des Kontakts.",
        add_candidate_est_cost: "Geschätzte Kosten",
        add_candidate_est_value_one: "≈ {{credits}} Credits ({{price}})",
        add_candidate_est_value_many: "≈ {{credits}} Credits für {{count}} Kontakte ({{price}})",
        add_candidate_est_balance: "Guthaben: {{balance}} Credits",
        add_candidate_est_hint: "Grobe Schätzung – die tatsächlichen Kosten hängen davon ab, was jeder Kontakt benötigt.\n\nTypische Sätze: Lebenslauf {{cv}}, LinkedIn {{li}}, Websuche {{web}}, Suchindex {{idx}} Credits.\n\nDie Websuche läuft nur, wenn sie aktiviert ist und der Kontakt genug Kontext hat – die tatsächlichen Kosten sind daher oft niedriger. 1.000 Credits ≈ {{price1k}}.",
        company_field_help: "Bekannte Firmen durchsuchen. Eine Übereinstimmung verknüpft diesen Kontakt mit anderen dort und reichert Firmendaten an — oder geben Sie einfach einen Namen frei ein.",
        enrichment_what_help: "Die Anreicherung füllt automatisch Werdegang, Ausbildung, Skills und Standort, indem hochgeladene Dokumente, das LinkedIn-Profil und eine Websuche ausgewertet werden. Sie läuft im Hintergrund beim Hinzufügen eines Kontakts, beim Hochladen eines Dokuments oder per „Neu anreichern“ — und verbraucht Credits.",
        enrich_status_none: "Nicht gestartet",
        enrich_status_pending: "In Warteschlange",
        enrich_status_extracting: "Dokumente werden gelesen",
        enrich_status_parsing: "KI-Analyse läuft",
        enrich_status_embedding: "Für Suche indexieren",
        enrich_status_complete: "Aktuell",
        enrich_status_failed: "Fehlgeschlagen",
        enrichment_failed_help: "Die Anreicherung konnte nicht abgeschlossen werden. Versuchen Sie „Neu anreichern“ oder prüfen Sie, ob die LinkedIn-URL korrekt ist.",
        enrich_web_nocontext_help: "Die Websuche benötigt mindestens eine Position oder Firma, um die richtige Person zu finden (damit es nicht zu einer Verwechslung mit einer gleichnamigen Person kommt). Ergänzen Sie oben Position oder Firma und führen Sie „Neu anreichern“ aus.",
        contacts_empty_title: "Noch keine Kontakte",
        contacts_empty_help: "Kontakte sind die Personen in Ihrer Datenbank. Manuell hinzufügen, eine LinkedIn-URL einfügen oder eine Datei importieren — jeder Kontakt wird automatisch angereichert.",
        projects_empty_title: "Noch keine Projekte",
        projects_empty_help: "Ein Projekt ist eine Suche für einen Klienten. Wählen Sie einen Klienten und eine Zielposition, um eine Pipeline zu starten.",
        clients_empty_title: "Noch keine Klienten",
        clients_empty_help: "Klienten sind die Firmen, für die Sie suchen. Fügen Sie einen hinzu, um Projekte dafür anzulegen.",
        roles_help: "Rollen kennzeichnen, wie Sie mit einem Kontakt arbeiten:\n• Kandidat — in einer Such-Pipeline\n• Klient — arbeitet bei einem Auftraggeber\n• Referenz — empfiehlt eine:n Kandidat:in\n• Source — hilft beim Finden von Kandidaten\n• Identifiziert — entdeckt, noch nicht angesprochen\n• Potenzial — interessant für künftige Suchen",
        pipeline_stages_help: "Die Phasen zeigen, wo ein Kontakt in dieser Suche steht:\n• Identifiziert — neuer Lead\n• Longlist — erfüllt die Basics\n• Shortlist — starke Passung\n• Interview — im Gespräch\n• Finalist — Endrunde\n• Platziert — besetzt\n• Abgelehnt — nicht weiter verfolgt\nKarte ziehen, um die Phase zu ändern.",
        consent_states_help: "Die Einwilligung steuert, ob Sie die Daten einer Person in Dokumenten und Vorschlägen verwenden dürfen:\n• Erteilt — nutzbar\n• Angefragt / Nicht angefragt — noch nicht\n• Abgelehnt / Widerrufen — Nutzung stoppen\n• Abgelaufen — erneut anfragen\n• Überfällig — angefragt, aber noch keine Antwort\n• Nicht anfragen — Sie haben sich entschieden, keine Einwilligung anzufragen",
      },
      translation: {},
    },
  },
});

export default i18next;
